<!--SearchItem控件-->
<template>
  <div
    style="height: auto;width: 100%;margin-top: 5px"
    class="cargo-advance-search"
  >
    <div v-if="showSimple" class="cargo-advance-search-header">
      <div class="cargo-advance-search-toggle-trigger">
        <i
          v-show="showAdv"
          no="upOrDown"
          class="el-icon-arrow-left"
          :style="{
            transform: !isShowingMoreSearchCondition
              ? 'rotate(-90deg)'
              : 'rotate(90deg)'
          }"
          @click="upOrDownSearchCondition"
        />
      </div>
      <div
        v-show="showSimple && !isShowingMoreSearchCondition"
        class="cargo-advance-search-quick"
      >
        <!--清空时不需要弹出提示，只有输入框为空，点击查询时才需要弹出提示-->
        <!--@clear="simSearch"-->
        <el-input
          v-model="keyWords"
          v-focus
          no="keyWords"
          style="width:200px;"
          clearable
          :placeholder="simQueryPlaceholderValue"
          :spellcheck="false"
          @change="keyWordCharge"
          @keyup.enter.native.prevent="simSearch"
        />
        <el-button
          no="Query"
          style="margin-left: 5px;height: 28px;"
          type="primary"
          :disabled="disabled || searchDisabled"
          @click="simSearch"
        >
          {{ $t('CargoMsg.Cargo_Query') }}
        </el-button>
      </div>
      <el-button
        v-if="showAdv"
        v-show="isShowingMoreSearchCondition"
        no="ComplexQuery"
        type="primary"
        :disabled="disabled || searchDisabled"
        style="margin-left:5px;margin-right: -5px;height: 28px"
        @click="advSearch"
      >{{ $t('CargoMsg.Cargo_Query') }}
      </el-button>
      <cargo-button-group-slider>
        <slot name="operations">
          <!--页面操作按钮-->
        </slot>
      </cargo-button-group-slider>
      <slot name="other">
        <!--其他内容-->
      </slot>
    </div>
    <div v-if="!showSimple&&$slots.operations" class="cargo-advance-search-header">
      <el-button
        v-show="isShowingMoreSearchCondition"
        type="primary"
        no="advSearch"
        :disabled="disabled || searchDisabled"
        style="margin-left:5px;margin-right: -5px;height: 28px"
        @click="advSearch"
      >{{ $t('CargoMsg.Cargo_Query') }}</el-button>
      <cargo-button-group-slider>
        <slot name="operations">
          <!--页面操作按钮-->
        </slot>
      </cargo-button-group-slider>
    </div>
    <slot name="searchAreaHeader">
      <!--搜索条件区域-头-->
    </slot>
    <div
      v-if="showAdv"
      v-show="isShowingMoreSearchCondition"
      class="section cargo-advance-search-more"
    >
      <div class="cargo-advance-search-more-operations">
        <div>
          <el-button
            v-if="!showSimple&&!$slots.operations"
            v-show="isShowingMoreSearchCondition"
            no="advSearch2"
            type="primary"
            :disabled="disabled || searchDisabled"
            @click="advSearch"
          >{{ $t('CargoMsg.Cargo_Query') }}
          </el-button>
          <el-button
            no="SaveChanges"
            type="primary"
            :disabled="disabled"
            plain
            @click="showSaveModifiedDialog"
          >{{ $t('CargoMsg.Cargo_SaveChanges') }}
          </el-button>
          <el-button
            no="ModifyFilter"
            type="primary"
            :disabled="disabled"
            plain
            @click="toShowConfigSearchItem"
          >{{ $t('CargoMsg.Cargo_ModifyFilter') }}
          </el-button>
          <el-button
            no="ResetFilter"
            type="primary"
            :disabled="disabled"
            plain
            @click="toResetFields"
          >{{ $t('CargoMsg.Cargo_ResetFilter') }}
          </el-button>
          <el-button
            no="SaveAsScheme"
            type="primary"
            :disabled="disabled"
            plain
            @click="showSaveSchemeDialog"
          >{{ $t('CargoMsg.Cargo_SaveAsScheme') }}
          </el-button>
          <el-checkbox v-show="isAppendQuery" v-model="appendQuery" no="appendQuery" class="append-checkbox">{{ $t('CargoMsg.Cargo_AppendQuery') }}</el-checkbox>
          <el-checkbox v-show="isCollapseList" v-model="collapseList" no="collapseList" class="append-checkbox" style="margin-left: -20px;" @change="clickCollapseList()">{{ $t('CargoMsg.Cargo_CollapseList') }}</el-checkbox>
          <el-checkbox v-show="isBranchCooperate" v-model="branchCooperate" no="branchCooperate" class="append-checkbox" style="margin-left: -20px;">{{ $t('CargoMsg.Cargo_BranchCooperate') }}</el-checkbox>
          <slot name="adv-operations">
            <!--页面操作按钮-->
          </slot>
        </div>
        <div style="display: flex;align-items: center;color: #1F75D5;margin-right: 20px;">{{ perConfigName }}</div>
        <div>
          <el-dropdown
            no="QueryScheme"
            trigger="click"
            placement="bottom-start"
            :hide-on-click="false"
            class="main-dropdown"
            @command="selectedPerConfigByCommand"
          >
            <el-button type="primary" plain :disabled="disabled">
              {{ $t('CargoMsg.Cargo_QueryScheme')
              }}<i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <div style="max-height: 300px;overflow-y: auto">
                <el-dropdown-item
                  v-for="(item,index) in perConfigs"
                  v-if="item && !item.bDefault"
                  :key="`${item.id}-${index}`"
                  :command="item.id"
                  :class="[item&&item.id === selectedConfigValue ? 'activeMenu' : '']"
                >{{ item.configName }}
                </el-dropdown-item>
              </div>
              <el-dropdown-item
                command="default"
                :class="[
                  defConfig&&defConfig.id === selectedConfigValue ? 'activeMenu' : ''
                ]"
                divided
              >{{ defConfig&&defConfig.configName }}
              </el-dropdown-item>
              <el-dropdown-item
                divided
                command="manage"
              >{{ $t('CargoMsg.Cargo_QuerySchemeManagement') }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <el-form
        v-show="isShowSearchItem"
        class="cargo-advance-search-form"
        label-width="75px"
        label-position="left"
        style="min-width: 830px;margin-right: 10px"
        :disabled="disabled"
      >
        <el-row type="flex" :gutter="6" style="flex-wrap: wrap">
          <el-col
            v-for="(item, index) in multipleSelection"
            :key="item.itemName + item.itemType + index + selectedConfigValue"
            :no="item.itemName"
            v-bind="colSettings"
          >
            <el-form-item>
              <!--itemTipLabel： 若存在该属性 则使用该属性为浮动提示-->
              <el-tooltip
                slot="label"
                :disabled="getLength(i18nAdvSearch('' + item.itemLabel)) < 12"
                effect="dark"
                :content="item.itemTipLabel ? i18nAdvSearch('' + item.itemTipLabel) : i18nAdvSearch('' + item.itemLabel)"
                placement="top"
                size="mini"
              >
                <span
                  style="display:inline-block;width:100%;overflow:hidden;white-space:nowrap;text-overflow: ellipsis;"
                >{{ i18nAdvSearch('' + item.itemLabel) }}</span>
              </el-tooltip>
              <div
                v-show="item.itemType !== 'sopStateTrack' && item.itemType !== 'ediStateQuery' && showCondition"
                style="display: inline-block;margin-right: 3px"
              >
                <!--条件-->
                <el-select
                  v-if="item.itemCondition && item.itemCondition.length > 0"
                  v-model="item.defaultConditionVal"
                  no="condition"
                  :disabled="item.lock"
                  style="width: 77px;display: inline-block"
                  size="mini"
                  :placeholder="$t('common.pleaseChoose')"
                  @change="onCondChange($event, item)"
                >
                  <el-option
                    v-for="(cond,index) in item.itemCondition || []"
                    :key="`${cond.code}-${index}`"
                    :label="
                      i18nAdvSearch('advanceSearchForm.' + cond.englishName)
                    "
                    :value="cond.code"
                  />
                </el-select>
                <!--<div v-else style="width: 80px;display: inline-block">表达式</div>-->
                <div v-else style="width: 80px;display: inline-block" />
              </div>

              <template v-if="item.itemType === 'input'">
                <template v-if="item.subType === 'bigdecimalForPositive'">
                  <el-input-number
                    :ref="
                      `${item.itemName}${item.itemType}${selectedConfigValue}`
                    "
                    v-model="item.itemValue"
                    :disabled="item.lock"
                    :max="99999999"
                    style="width: 100%"
                    size="mini"
                    :precision="2"
                    :step="1"
                    controls-position="right"
                    :placeholder="emptyPlaceholder"
                    @keydown.native.enter.prevent="onAdvSelectEnter"
                    @keyup.enter.native.prevent="onInputEnter"
                  />
                </template>
                <template v-else-if="item.subType === 'bigdecimalrange'">
                  <el-input-number
                    :ref="
                      `${item.itemName}${item.itemType}${selectedConfigValue}`
                    "
                    v-model="item.itemValue1"
                    no="header"
                    :disabled="item.lock"
                    :min="0"
                    :max="item.itemValue2 || 99999999"
                    style="width: 49%"
                    size="mini"
                    :precision="item.itemName === 'job.QUANTITY_CONTRACT' ? 0 : 2"
                    :step="1"
                    controls-position="right"
                    :placeholder="emptyPlaceholder"
                    @keydown.native.enter.prevent="onAdvSelectEnter"
                    @keyup.enter.native.prevent="onInputEnter"
                    @blur="
                      e => {
                        if (e.target.value <= 0) item.itemValue1 = undefined
                      }
                    "
                  />
                  <span style="width: 2%">-</span>
                  <el-input-number
                    :ref="
                      `${item.itemName}${item.itemType}${selectedConfigValue}`
                    "
                    v-model="item.itemValue2"
                    no="tail"
                    :disabled="item.lock"
                    :min="item.itemValue1 || 0"
                    :max="99999999"
                    style="width: 49%"
                    size="mini"
                    :precision="item.itemName === 'job.QUANTITY_CONTRACT' ? 0 : 2"
                    :step="1"
                    controls-position="right"
                    :placeholder="emptyPlaceholder"
                    @keydown.native.enter.prevent="onAdvSelectEnter"
                    @keyup.enter.native.prevent="onInputEnter"
                    @blur="
                      e => {
                        if (e.target.value <= 0) item.itemValue2 = undefined
                      }
                    "
                  />
                </template>
                <template
                  v-else-if="item.subType === 'bigdecimalrangeForPositive'"
                >
                  <el-input-number
                    :ref="
                      `${item.itemName}${item.itemType}${selectedConfigValue}`
                    "
                    v-model="item.itemValue1"
                    no="header"
                    :disabled="item.lock"
                    :max="item.itemValue2 || 99999999"
                    :precision="2"
                    :step="1"
                    style="width: 49%"
                    size="mini"
                    controls-position="right"
                    :placeholder="emptyPlaceholder"
                    @keydown.native.enter.prevent="onAdvSelectEnter"
                    @keyup.enter.native.prevent="onInputEnter"
                  />
                  <span style="width:2%">-</span>
                  <el-input-number
                    :ref="
                      `${item.itemName}${item.itemType}${selectedConfigValue}`
                    "
                    v-model="item.itemValue2"
                    no="tail"
                    :disabled="item.lock"
                    :min="item.itemValue1 || 0"
                    :max="99999999"
                    :precision="2"
                    :step="1"
                    style="width: 49%"
                    size="mini"
                    controls-position="right"
                    :placeholder="emptyPlaceholder"
                    @keydown.native.enter.prevent="onAdvSelectEnter"
                    @keyup.enter.native.prevent="onInputEnter"
                  />
                </template>
                <template v-else-if="item.subType === 'numberText'">
                  <el-input
                    :value="item.itemValue"
                    clearable
                    size="mini"
                    class="textInput"
                    :placeholder="emptyPlaceholder"
                    @input="
                      value => {
                        item.itemValue = value.replace(/[^\d]/g, '')
                      }
                    "
                    @keydown.native.enter.prevent="onAdvSelectEnter"
                    @keyup.enter.native.prevent="onInputEnter"
                  />
                </template>
                <template v-else-if="item.subType === 'charRange'">
                  <el-input
                    :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                    v-model="item.itemValue1"
                    no="header"
                    :disabled="item.lock"
                    style="width: 49%"
                    clearable
                    size="mini"
                    :placeholder="$t('CargoMsg.Cargo_RangeSmaller')"
                    @keydown.native.enter.prevent="onAdvSelectEnter"
                    @keyup.enter.native.prevent="onInputEnter"
                  />
                  <span style="width:2%">-</span>
                  <el-input
                    :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                    v-model="item.itemValue2"
                    no="tail"
                    :disabled="item.lock"
                    style="width: 49%"
                    clearable
                    size="mini"
                    :placeholder="$t('CargoMsg.Cargo_RangeSmaller')"
                    @keydown.native.enter.prevent="onAdvSelectEnter"
                    @keyup.enter.native.prevent="onInputEnter"
                  />
                </template>
                <template v-else-if="item.subType === 'bigdecimalrangeWithPrecision'">
                  <el-input-number
                    :ref="
                      `${item.itemName}${item.itemType}${selectedConfigValue}`
                    "
                    v-model="item.itemValue1"
                    no="header"
                    :disabled="item.lock"
                    :min="0"
                    :max="item.itemValue2 || 99999999"
                    style="width: 49%"
                    size="mini"
                    :precision="item.precision ? item.precision : 0"
                    :step="1"
                    controls-position="right"
                    :placeholder="emptyPlaceholder"
                    @keydown.native.enter.prevent="onAdvSelectEnter"
                    @keyup.enter.native.prevent="onInputEnter"
                    @blur="
                      e => {
                        if (e.target.value <= 0) item.itemValue1 = undefined
                      }
                    "
                  />
                  <span style="width: 2%">-</span>
                  <el-input-number
                    :ref="
                      `${item.itemName}${item.itemType}${selectedConfigValue}`
                    "
                    v-model="item.itemValue2"
                    no="tail"
                    :disabled="item.lock"
                    :min="item.itemValue1 || 0"
                    :max="99999999"
                    style="width: 49%"
                    size="mini"
                    :precision="item.precision ? item.precision : 0"
                    :step="1"
                    controls-position="right"
                    :placeholder="emptyPlaceholder"
                    @keydown.native.enter.prevent="onAdvSelectEnter"
                    @keyup.enter.native.prevent="onInputEnter"
                    @blur="
                      e => {
                        if (e.target.value <= 0) item.itemValue2 = undefined
                      }
                    "
                  />
                </template>
                <template v-else-if="item.defaultConditionVal === 'IS IT EMPTY' || item.defaultConditionVal === 'IS IT NOT EMPTY'">
                  <cargo-advance-select
                    :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                    :disabled="item.lock"
                    :select-type="selectTypeNames[item.dataCacheKey]"
                    :callback-params="{
                      refCode: item.itemName,
                      fieldType: item.fieldType
                    }"
                    :default-value="item.itemValue"
                    options-width="450px"
                    :placeholder="emptyPlaceholder"
                    :headers="item.headers || []"
                    :fields="item.fields || []"
                    :tag-name="item.tagName"
                    :tag-value="item.tagValue"
                    @enter="onAdvSelectEnter"
                    @parentCallBack="getValueFromChild"
                  />
                </template>
                <template v-else>
                  <el-input
                    v-model="item.itemValue"
                    :disabled="item.defaultConditionVal === 'IS NULL' || item.lock"
                    clearable
                    size="mini"
                    class="textInput"
                    :placeholder="emptyPlaceholder"
                    @keydown.native.enter.prevent="onAdvSelectEnter"
                    @keyup.enter.native.prevent="onInputEnter"
                  />
                </template>
              </template>

              <el-input
                v-if="item.itemType === 'input-m'"
                :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                v-model="item.itemValue"
                size="mini"
                disabled
                :placeholder="emptyPlaceholder"
                @keydown.native.enter.prevent="onAdvSelectEnter"
                @keyup.enter.native.prevent="onInputEnter"
              >
                <el-button
                  slot="append"
                  size="mini"
                  :disabled="item.lock"
                  @click="toShowEditTextArea(item)"
                >...
                </el-button>
              </el-input>
              <!--多行文本，逗号隔开 multiText-->
              <cargo-multi-line-text-popover
                v-if="item.itemType === 'multiText' || item.itemType === 'multiTextAndExclude' || (item.itemType === 'overseaWarehouse' && item.subType === 'multiText' && 'BATCH' === item.defaultConditionVal)"
                :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                :show-popover="'BATCH' === item.defaultConditionVal || 'BATCH_EXCLUDE' === item.defaultConditionVal || 'REGEXP' === item.defaultConditionVal"
                :separator="'REGEXP' === item.defaultConditionVal ? '|' : ','"
                :disabled="item.lock"
                :value.sync="item.itemValue"
                style="width:100%"
                :visible-arrow="false"
                :placeholder="emptyPlaceholder"
                @inputEnter="onInputEnter"
              />
              <!--CARGO-26061 要求有等于、不等于、包含、批量，为空操作 额外定义为空操作时禁用输入框-->
              <cargo-multi-line-text-popover
                v-if="item.itemType === 'multiText2' || item.itemType === 'multiText3'"
                :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                :show-popover="'BATCH' === item.defaultConditionVal || 'BATCH_EXCLUDE' === item.defaultConditionVal || 'REGEXP' === item.defaultConditionVal"
                :separator="'REGEXP' === item.defaultConditionVal ? '|' : ','"
                :disabled="item.lock"
                :input-disabled="item.defaultConditionVal === 'IS NULL' || item.defaultConditionVal === 'IS NOT NULL'"
                :value.sync="item.itemValue"
                style="width:100%"
                :visible-arrow="false"
                :placeholder="emptyPlaceholder"
                @inputEnter="onInputEnter"
              />
              <!--状态追踪-->
              <template v-if="item.itemType === 'sopStateTrack'">
                <el-input
                  :ref="
                    `${item.itemName}${item.itemType}${selectedConfigValue}`
                  "
                  v-model="sopStateTrack.currentItem.txtContent"
                  size="mini"
                  readonly
                  :placeholder="$t('advanceSearchForm.doubleClickToSelect')"
                  @dblclick.native="toShowSopStateTrack(item)"
                >
                  <!--                    <el-button slot="append" size="mini" :disabled="item.lock" @click="toShowSopStateTrack(item)">...-->
                  <!--                    </el-button>-->
                </el-input>
                <el-button
                  v-show="!!sopStateTrack.currentItem.txtContent"
                  size="mini"
                  :disabled="item.lock"
                  @click="toClearSopStateTrack(item)"
                >{{ $t('Message.Clear') }}
                </el-button>
              </template>
              <!--EDI状态查询-->
              <template v-if="item.itemType === 'ediStateQuery'">
                <el-input
                  :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                  :value="item.txtContent"
                  size="mini"
                  readonly
                  :placeholder="$t('Message.DoubleClickToSelectState')"
                  @dblclick.native="toShowEdiStateQueryDialog(item)"
                />
                <el-button
                  v-show="!!item.txtContent"
                  size="mini"
                  :disabled="item.lock"
                  @click="toClearSpecialQuery(item)"
                >{{ $t('CargoMsg.Cargo_Clear') }}</el-button>
              </template>
              <!-- todo 遗留扩展, 可根据查询条件 切换下拉-->
              <template
                v-if="item.itemType === 'date' && item.subType === 'daymicDate'"
              >
                <cargo-date-time-picker
                  v-if="item.defaultConditionVal === 'RANGE'"
                  key="2"
                  v-model="item.itemValue"
                  :disabled="item.lock"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  size="mini"
                  clearable
                  :placeholder="emptyPlaceholder"
                  @keydown.native.enter.prevent="onAdvSelectEnter"
                />
                <!--快捷选择-->
                <el-select
                  v-else-if="item.defaultConditionVal === 99"
                  v-model="item.itemValue"
                  :disabled="item.lock"
                  :placeholder="emptyPlaceholder"
                >
                  <el-option
                    v-for="(_item,index) in shortcutDates"
                    :key="`${_item.value}-${index}`"
                    :label="i18nAdvSearch(_item.label)"
                    :value="_item.value"
                  />
                </el-select>
                <cargo-date-time-picker
                  v-else
                  key="1"
                  v-model="item.itemValue"
                  :disabled="item.lock"
                  value-format="yyyy-MM-dd"
                  size="mini"
                  clearable
                  :placeholder="emptyPlaceholder"
                  @keydown.native.enter.prevent="onAdvSelectEnter"
                />
              </template>
              <!-- 日期控件 开始截止-->
              <template v-if="item.itemType === 'date'">
                <template v-if="item.defaultConditionVal !== 'DATE ITEM'">
                  <cargo-date-time-picker
                    :ref="
                      `${item.itemName}${item.itemType}${selectedConfigValue}`
                    "
                    v-model="item.itemValue[0]"
                    no="begin"
                    :disabled="
                      item.lock || item.defaultConditionVal !== 'RANGE'
                    "
                    value-format="yyyy-MM-dd"
                    type="date"
                    clearable
                    style="width: 49%"
                    :picker-options="{
                      disabledDate: time => {
                        const endDate = item.itemValue[1] ? new Date(item.itemValue[1] + ' 23:59:59') : null;
                        if (endDate) {
                          // 基础限制：限制开始日期不能晚于结束日期
                          if (time.getTime() > endDate.getTime()) {
                            return true;
                          }
                          //判断是否启用 3 个月限制
                          if (item.filterType === 'THREE_MONTH') {
                            return time.getTime() < getThreeMonthsAgo(endDate).getTime()- 24 * 60 * 60 * 1000; //如果大于3个月之前，不可操作
                          }
                        }
                        return false
                      }
                    }"
                    :placeholder="emptyPlaceholder"
                    @focus="() => handleDateRangeFocus(item)"
                    @blur="() => handleDateRangeBlur(item)"
                    @change="() => datePickerChange(item)"
                  />
                  <span style="width: 2%"> - </span>
                  <cargo-date-time-picker
                    :ref="
                      `${item.itemName}${item.itemType}${selectedConfigValue}`
                    "
                    v-model="item.itemValue[1]"
                    no="end"
                    :disabled="
                      item.lock || item.defaultConditionVal !== 'RANGE'
                    "
                    value-format="yyyy-MM-dd"
                    type="date"
                    clearable
                    style="width: 49%"
                    :picker-options="{
                      disabledDate: time => {
                        const startDate = item.itemValue[0] ? new Date(item.itemValue[0] + ' 00:00:00') : null;
                        if (startDate) {
                          // 基础限制：结束日期不能早于开始日期
                          if (time.getTime() < startDate.getTime()) {
                            return true;
                          }
                          //判断是否启用 3 个月限制
                          if (item.filterType === 'THREE_MONTH') {
                            return time.getTime() > getThreeMonthsLater(startDate).getTime(); //如果结束日期在3个月之后不可操作
                          }
                        }
                        return false;
                      }
                    }"
                    :placeholder="emptyPlaceholder"
                    @focus="() => handleDateRangeFocus(item)"
                    @blur="() => handleDateRangeBlur(item)"
                    @change="() => datePickerChange(item)"
                  />
                </template>
                <template v-else>
                  <el-select v-model="item.itemValue" :disabled="item.lock" :placeholder="emptyPlaceholder">
                    <el-option
                      v-for="(_item,index) in (item.dateItemExtend === 1 ? [...shortcutDatesExtend, ...shortcutDates] : shortcutDates)"
                      :key="`${_item.value}-${index}`"
                      :label="i18nAdvSearch(_item.label)"
                      :value="_item.value"
                    />
                  </el-select>
                </template>
              </template>
              <!-- 日期控件 单个日期-->
              <template
                v-if="item.itemType === 'singleDate'"
              >
                <cargo-date-time-picker
                  key="1"
                  v-model="item.itemValue"
                  style="width: 100%"
                  :disabled="item.lock"
                  value-format="yyyy-MM-dd"
                  size="mini"
                  clearable
                  :placeholder="emptyPlaceholder"
                  @keydown.native.enter.prevent="onAdvSelectEnter"
                />
              </template>

              <!-- el-select 位置请勿随意移动，优先级比较高-->
              <el-select
                v-if="
                  item.itemType === 'select' &&
                    item.valueExpression &&
                    item.valueExpression.valueType === 'static'
                "
                :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                v-model="item.itemValue"
                class="multi-select"
                :disabled="item.lock"
                :multiple="item.multiple === 1"
                :collapse-tags="true"
                filterable
                clearable
                size="mini"
                :placeholder="emptyPlaceholder"
                @keydown.native.enter.prevent="onAdvSelectEnter"
                @change="
                  () =>
                    convertSelectedToText(
                      `${item.itemName}${item.itemType}${selectedConfigValue}`
                    )
                "
              >
                <el-option
                  v-for="(_item,index) in item.valueExpression.valueContent"
                  :key="`${_item.code}-${index}`"
                  :label="
                    $store.getters.language === 'zh'
                      ? _item.chineseName
                      : _item.englishName
                  "
                  :value="_item.code"
                />
              </el-select>
              <!--状态类型-->
              <el-select
                v-if="item.itemType === 'stateTypes'"
                :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                v-model="item.itemValue"
                class="multi-select"
                :disabled="item.lock"
                :multiple="item.multiple === 1"
                clearable
                collapse-tags
                size="mini"
                :placeholder="emptyPlaceholder"
                @keydown.native.enter.prevent="onAdvSelectEnter"
                @change="
                  () =>
                    convertSelectedToText(
                      `${item.itemName}${item.itemType}${selectedConfigValue}`
                    )
                "
              >
                <el-option
                  v-for="(_item,index) in stateTypes"
                  :key="`${_item.code}-${index}`"
                  :label="$store.getters.language==='zh'?_item.chineseName:_item.englishName"
                  :value="_item.code"
                />
              </el-select>
              <!--  铁路航线 支持单选或多选 -->
              <cargo-advance-select
                v-if="item.itemType === 'railwayLine2'"
                :key="`rl2-${item.itemName}-${item.defaultConditionVal}-${selectedConfigValue}`"
                :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                filterable
                :disabled="item.lock"
                :callback-params="{ refCode: item.itemName }"
                :default-multiple-value="
                  item.defaultConditionVal === AdvancedSearchConsts.OPERATOR_IN.code && item.multiple === 1
                    ? (item.itemValue instanceof Array ? item.itemValue : [])
                    : []
                "
                :default-value="
                  item.defaultConditionVal === AdvancedSearchConsts.OPERATOR_IN.code && item.multiple === 1
                    ? ''
                    : (item.itemValue instanceof Array ? (item.itemValue[0] || '') : item.itemValue)
                "
                :multiple="item.multiple == 1 && item.defaultConditionVal === AdvancedSearchConsts.OPERATOR_IN.code"
                :select-type="selectTypeNames.basic_data_RailwayLine"
                :method-params="{}"
                :headers="item.headers || []"
                :fields="item.fields || []"
                :tag-name="item.tagName"
                :tag-value="item.tagValue"
                :placeholder="emptyPlaceholder"
                @enter="onAdvSelectEnter"
                @parentCallBack="getValueFromChild"
              />
              <div v-if="item.itemType === 'roleType'" style="display: flex;width: 100%;">
                <!-- 岗位类型 -->
                <cargo-advance-select
                  :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                  no="roleType"
                  filterable
                  :clearable="false"
                  :disabled="item.lock"
                  :callback-params="{ refCode: item.itemName }"
                  :default-value="item.itemValue"
                  :select-type="selectTypeNames.local_cache_CargoOfRoleType"
                  :static-options="item.dataProvider || (item.valueExpression ? item.valueExpression.valueContent : null)"
                  :method-params="{}"
                  :headers="item.headers || []"
                  :fields="item.fields || [$store.getters.language==='zh'?'chineseName':'englishName']"
                  :tag-name="$store.getters.language==='zh'?'chineseName':'englishName'"
                  :tag-value="item.tagValue"
                  :placeholder="emptyPlaceholder"
                  @enter="onAdvSelectEnter"
                  @parentCallBack="getValueFromChild"
                />
                <!--  岗位类型对应的用户 -->
                <cargo-advance-select
                  v-if="item.cascade"
                  :ref="
                    `${item.cascade.itemName}${item.cascade.itemType}${selectedConfigValue}`
                  "
                  no="roleTypeUser"
                  :url="url.sys.getUsersByPrivilegeDetail"
                  :cache="false"
                  filterable
                  :method-params="{ category: 'role', shape: '', officeId: '' }"
                  :callback-params="{
                    refCode: item.cascade.itemName,
                    cascade: true,
                    superItem: item
                  }"
                  :default-value="item.cascade.itemValue"
                  :select-type="selectTypeNames.basic_data_User"
                  :headers="item.cascade.headers || []"
                  :fields="item.cascade.fields || [$store.getters.language==='zh'?'chineseName':'englishName']"
                  :tag-name="item.cascade.tagName"
                  :tag-value="item.cascade.tagValue"
                  style="margin-left: 3px;"
                  :placeholder="emptyPlaceholder"
                  @enter="onAdvSelectEnter"
                  @parentCallBack="obj => (item.cascade.itemValue = obj.value)"
                />
              </div>
              <!--  船名 支持单选或多选，船名航次是级联关系，比较特殊 -->
              <cargo-advance-select
                v-if="item.itemType === 'vessel'"
                :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                filterable
                :disabled="item.lock"
                :callback-params="{ refCode: item.itemName }"
                :default-multiple-value="
                  item.multiple === 1 ? item.itemValue : []
                "
                :default-value="item.multiple === 1 ? '' : item.itemValue"
                :multiple="item.multiple == 1"
                :select-type="selectTypeNames.basic_data_Vessel"
                :method-params="{}"
                :headers="item.headers || []"
                :fields="item.fields || []"
                :tag-name="item.tagName"
                :tag-value="item.tagValue"
                :placeholder="emptyPlaceholder"
                @enter="onAdvSelectEnter"
                @parentCallBack="
                  obj => {
                    item.vesselId = obj.vesselId
                    getValueFromChild(obj)
                  }
                "
              />
              <!--  航次，船名航次是级联关系，比较特殊 -->
              <template v-if="item.itemType === 'vessel' && item.cascade">
                <el-input
                  v-if="!item.itemValue"
                  v-model="item.cascade.itemValue"
                  :placeholder="emptyPlaceholder"
                  @keyup.enter.native.prevent="onInputEnter"
                />
                <cargo-advance-select
                  v-else
                  :ref="
                    `${item.cascade.itemName}${item.cascade.itemType}${selectedConfigValue}`
                  "
                  filterable
                  :disabled="item.cascade.lock"
                  :url="url.mdm.getVoyagesByVesselId"
                  :cache="false"
                  allow-create
                  :method-params="{ vesselId: item.vesselId || ' ' }"
                  :callback-params="{
                    refCode: item.cascade.itemName,
                    cascade: true,
                    superItem: item
                  }"
                  :default-value="item.cascade.itemValue"
                  :select-type="selectTypeNames.static_data_Voyage"
                  :headers="item.cascade.headers || []"
                  :fields="item.cascade.fields || []"
                  :tag-name="item.cascade.tagName"
                  :tag-value="item.cascade.tagValue"
                  :placeholder="emptyPlaceholder"
                  @enter="onAdvSelectEnter"
                  @parentCallBack="obj => (item.cascade.itemValue = obj.value)"
                />
              </template>
              <!--海港-->
              <template v-if="item.itemType === 'seaport'">
                <cargo-advance-select
                  v-if="item.defaultConditionVal === 'IN' || item.defaultConditionVal === 'NOT IN'"
                  key="seaport-multiple"
                  :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                  filterable
                  :callback-params="{
                    refCode: item.itemName,
                    itemType: 'seaport'
                  }"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  :default-multiple-value="item.itemValue instanceof Array ? item.itemValue : []"
                  :method-params="{}"
                  :multiple="true"
                  :disabled="item.lock"
                  :headers="item.headers || []"
                  :fields="item.fields || []"
                  :tag-name="item.tagName"
                  :tag-value="item.tagValue"
                  :placeholder="emptyPlaceholder"
                  @enter="onAdvSelectEnter"
                  @parentCallBack="getValueFromChild"
                />
                <cargo-advance-select
                  v-else
                  key="seaport-single"
                  :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                  filterable
                  :callback-params="{
                    refCode: item.itemName,
                    itemType: 'seaport'
                  }"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  :default-value="item.itemValue instanceof Array ? '' : item.itemValue"
                  :method-params="{}"
                  :disabled="item.lock"
                  :headers="item.headers || []"
                  :fields="item.fields || []"
                  :tag-name="item.tagName"
                  :tag-value="item.tagValue"
                  :placeholder="emptyPlaceholder"
                  @enter="onAdvSelectEnter"
                  @parentCallBack="getValueFromChild"
                />
              </template>
              <!--空港-->
              <cargo-advance-select
                v-if="item.itemType === 'airport'"
                :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                filterable
                :disabled="item.lock"
                :callback-params="{
                  refCode: item.itemName,
                  itemType: 'airport'
                }"
                :select-type="selectTypeNames.basic_data_Airport"
                :default-value="item.itemValue"
                :method-params="{}"
                :headers="item.headers || []"
                :fields="item.fields || []"
                :tag-name="item.tagName"
                :tag-value="item.tagValue"
                :placeholder="emptyPlaceholder"
                @enter="onAdvSelectEnter"
                @parentCallBack="getValueFromChild"
              />
              <!--国家-->
              <template v-if="item.itemType === 'country'">
                <cargo-advance-select
                  v-if="item.defaultConditionVal === 'IN' || item.defaultConditionVal === 'NOT IN'"
                  key="country-multiple"
                  :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                  :select-type="selectTypeNames.basic_data_Country"
                  :callback-params="{ refCode: item.itemName }"
                  url=""
                  filterable
                  :multiple="true"
                  :disabled="item.lock"
                  :default-multiple-value="
                    item.multiple === 1 ? item.itemValue : []
                  "
                  :default-value="item.multiple === 1 ? '' : item.itemValue"
                  options-width="200px"
                  :headers="item.headers || []"
                  :fields="item.fields || []"
                  :tag-name="item.tagName"
                  :tag-value="item.tagValue"
                  :placeholder="emptyPlaceholder"
                  @enter="onAdvSelectEnter"
                  @parentCallBack="getValueFromChild"
                />
                <cargo-advance-select
                  v-else
                  :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                  :select-type="selectTypeNames.basic_data_Country"
                  filterable
                  :disabled="item.lock"
                  :callback-params="{ refCode: item.itemName }"
                  :default-value="item.itemValue"
                  :headers="item.headers || []"
                  :fields="item.fields || []"
                  :tag-name="item.tagName"
                  :tag-value="item.tagValue"
                  :placeholder="emptyPlaceholder"
                  @enter="onAdvSelectEnter"
                  @parentCallBack="getValueFromChild"
                >
                  <template slot-scope="{ option: { item, fields } }">
                    <div
                      style="display: flex;justify-content: space-between;width:400px;"
                    >
                      <div v-for="(field,index) in fields" :key="`${field}-${index}`" style="width:30%">
                        {{ item[field] }}
                      </div>
                    </div>
                  </template>
                </cargo-advance-select>
              </template>
              <!--用户-->
              <template v-if="item.itemType === 'userSea' || item.itemType === 'user' || item.itemType === 'user2' ">
                <cargo-advance-select
                  v-if="item.defaultConditionVal === 'IN' || item.defaultConditionVal === 'NOT IN'"
                  key="user-multiple"
                  :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                  :select-type="selectTypeNames.basic_data_User"
                  :url="item.lock ? '' : url.sys.getUsersByPrivilegeDetail"
                  :cache="item.lock"
                  :method-params="
                    Object.assign(
                      { officeId: $store.getters.currentOfficeId },
                      item.subType
                    )
                  "
                  :clear-not-match="!item.lock"
                  filterable
                  :disabled="item.lock || item.defaultConditionVal === AdvancedSearchConsts.OPERATOR_IS_NULL.code"
                  :callback-params="{ refCode: item.itemName }"
                  :default-multiple-value="item.itemValue instanceof Array ? item.itemValue : []"
                  :multiple="true"
                  callback-method-type="obj"
                  options-width="300px"
                  :headers="item.headers || []"
                  :fields="item.fields || []"
                  :tag-name="item.tagName"
                  :tag-value="item.tagValue"
                  :placeholder="emptyPlaceholder"
                  @enter="onAdvSelectEnter"
                  @parentCallBack="getValueFromChild"
                />
                <cargo-advance-select
                  v-else
                  key="user-single"
                  :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                  :select-type="selectTypeNames.basic_data_User"
                  :url="item.lock ? '' : url.sys.getUsersByPrivilegeDetail"
                  :cache="item.lock"
                  :method-params="
                    Object.assign(
                      { officeId: $store.getters.currentOfficeId },
                      item.subType
                    )
                  "
                  :clear-not-match="!item.lock"
                  filterable
                  :disabled="item.lock || item.defaultConditionVal === AdvancedSearchConsts.OPERATOR_IS_NULL.code"
                  :callback-params="{ refCode: item.itemName }"
                  :default-value="item.itemValue instanceof Array ? '' : item.itemValue"
                  callback-method-type="obj"
                  options-width="300px"
                  :headers="item.headers || []"
                  :fields="item.fields || []"
                  :tag-name="item.tagName"
                  :tag-value="item.tagValue"
                  :placeholder="emptyPlaceholder"
                  @enter="onAdvSelectEnter"
                  @parentCallBack="getValueFromChild"
                />
              </template>
              <template v-if="item.itemType === 'allUser'">
                <cargo-advance-select
                  key="user-single"
                  :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                  :select-type="selectTypeNames.basic_data_User"
                  :method-params="{officeId:0}"
                  :clear-not-match="true"
                  filterable
                  :disabled="item.lock"
                  :callback-params="{ refCode: item.itemName }"
                  :default-value="item.itemValue instanceof Array ? '' : item.itemValue"
                  :multiple="item.multiple === 1"
                  :default-multiple-value="item.multiple === 1 ? item.itemValue : []"
                  callback-method-type="obj"
                  options-width="300px"
                  :headers="item.headers || []"
                  :fields="item.fields || []"
                  :tag-name="item.tagName"
                  :tag-value="item.tagValue"
                  :placeholder="emptyPlaceholder"
                  @enter="onAdvSelectEnter"
                  @parentCallBack="getValueFromChild"
                />
              </template>
              <!--用户（如果是总部的情况下，支持查所有的对应角色的服务人员）-->
              <template v-if="item.itemType === 'allOfficeUser'">
                <cargo-advance-select
                  v-if="item.defaultConditionVal === 'IN' || item.defaultConditionVal === 'NOT IN'"
                  key="user-multiple"
                  :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                  :select-type="selectTypeNames.basic_data_User"
                  :url="url.sys.getUsersByPrivilegeDetail"
                  :cache="false"
                  :method-params="
                    Object.assign(
                      { officeId: $store.getters.currentOfficeId === 1 ? '' : $store.getters.currentOfficeId},
                      item.subType
                    )
                  "
                  :clear-not-match="true"
                  filterable
                  :disabled="item.lock"
                  :callback-params="{ refCode: item.itemName }"
                  :default-multiple-value="item.itemValue instanceof Array ? item.itemValue : []"
                  :multiple="true"
                  callback-method-type="obj"
                  options-width="300px"
                  :headers="item.headers || []"
                  :fields="item.fields || []"
                  :tag-name="item.tagName"
                  :tag-value="item.tagValue"
                  :placeholder="emptyPlaceholder"
                  @enter="onAdvSelectEnter"
                  @parentCallBack="getValueFromChild"
                />
                <cargo-advance-select
                  v-else
                  key="user-single"
                  :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                  :select-type="selectTypeNames.basic_data_User"
                  :url="url.sys.getUsersByPrivilegeDetail"
                  :cache="false"
                  :method-params="
                    Object.assign(
                      { officeId: $store.getters.currentOfficeId === 1 ? '' : $store.getters.currentOfficeId},
                      item.subType
                    )
                  "
                  :clear-not-match="true"
                  filterable
                  :disabled="item.lock"
                  :callback-params="{ refCode: item.itemName }"
                  :default-value="item.itemValue instanceof Array ? '' : item.itemValue"
                  callback-method-type="obj"
                  options-width="300px"
                  :headers="item.headers || []"
                  :fields="item.fields || []"
                  :tag-name="item.tagName"
                  :tag-value="item.tagValue"
                  :placeholder="emptyPlaceholder"
                  @enter="onAdvSelectEnter"
                  @parentCallBack="getValueFromChild"
                />
              </template>
              <!--对应角色的用户-->
              <template v-if="item.itemType === 'allUser2'">
                <cargo-advance-select
                  v-if="item.defaultConditionVal === 'IN' || item.defaultConditionVal === 'NOT IN'"
                  key="user-multiple"
                  :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                  :select-type="selectTypeNames.basic_data_User"
                  :url="url.sys.getUsersByPrivilegeDetail"
                  :cache="false"
                  :method-params="
                    Object.assign(
                      item.subType
                    )
                  "
                  :clear-not-match="true"
                  filterable
                  :disabled="item.lock"
                  :callback-params="{ refCode: item.itemName }"
                  :default-multiple-value="item.itemValue instanceof Array ? item.itemValue : []"
                  :multiple="true"
                  callback-method-type="obj"
                  options-width="300px"
                  :headers="item.headers || []"
                  :fields="item.fields || []"
                  :tag-name="item.tagName"
                  :tag-value="item.tagValue"
                  :placeholder="emptyPlaceholder"
                  @enter="onAdvSelectEnter"
                  @parentCallBack="getValueFromChild"
                />
                <cargo-advance-select
                  v-else
                  key="user-single"
                  :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                  :select-type="selectTypeNames.basic_data_User"
                  :url="url.sys.getUsersByPrivilegeDetail"
                  :cache="false"
                  :method-params="
                    Object.assign(
                      item.subType
                    )
                  "
                  :clear-not-match="true"
                  filterable
                  :disabled="item.lock"
                  :callback-params="{ refCode: item.itemName }"
                  :default-value="item.itemValue instanceof Array ? '' : item.itemValue"
                  callback-method-type="obj"
                  options-width="300px"
                  :headers="item.headers || []"
                  :fields="item.fields || []"
                  :tag-name="item.tagName"
                  :tag-value="item.tagValue"
                  :placeholder="emptyPlaceholder"
                  @enter="onAdvSelectEnter"
                  @parentCallBack="getValueFromChild"
                />
              </template>
              <!--费用项-->
              <template v-if="item.itemType === 'chargeItem'">
                <cargo-advance-select
                  v-if="item.defaultConditionVal === 'IN' || item.defaultConditionVal === 'NOT IN'"
                  key="chargeItem-multiple"
                  :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                  :select-type="selectTypeNames.basic_data_ChargeItem"
                  :callback-params="{ refCode: item.itemName }"
                  url=""
                  :disabled="item.lock"
                  :default-multiple-value="item.itemValue instanceof Array ? item.itemValue : []"
                  :multiple="true"
                  filterable
                  options-width="450px"
                  :headers="item.headers || []"
                  :fields="item.fields || []"
                  :tag-name="item.tagName"
                  :tag-value="item.tagValue"
                  :placeholder="emptyPlaceholder"
                  @enter="onAdvSelectEnter"
                  @parentCallBack="getValueFromChild"
                />
                <cargo-advance-select
                  v-else
                  key="chargeItem-single"
                  :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                  :select-type="selectTypeNames.basic_data_ChargeItem"
                  :callback-params="{ refCode: item.itemName }"
                  url=""
                  :disabled="item.lock"
                  :default-value="item.itemValue instanceof Array ? '' : item.itemValue"
                  filterable
                  options-width="450px"
                  :headers="item.headers || []"
                  :fields="item.fields || []"
                  :tag-name="item.tagName"
                  :tag-value="item.tagValue"
                  :placeholder="emptyPlaceholder"
                  @enter="onAdvSelectEnter"
                  @parentCallBack="getValueFromChild"
                />
              </template>
              <!--结算方式-->
              <cargo-advance-select
                v-if="item.itemType === 'settlementMethod'"
                :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                :callback-params="{ refCode: item.itemName }"
                :select-type="selectTypeNames.local_cache_SettlementMethod"
                :default-multiple-value="
                  item.multiple === 1 ? item.itemValue : []
                "
                :default-value="item.multiple === 1 ? '' : item.itemValue"
                :multiple="item.multiple == 1"
                filterable
                :disabled="item.lock"
                options-width="450px"
                :headers="item.headers || []"
                :fields="item.fields || []"
                :tag-name="item.tagName"
                :tag-value="item.tagValue"
                :placeholder="emptyPlaceholder"
                @enter="onAdvSelectEnter"
                @parentCallBack="getValueFromChild"
              />
              <!--结算类型-->
              <cargo-advance-select
                v-if="item.itemType === 'settlementType'"
                :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                :callback-params="{ refCode: item.itemName }"
                :select-type="selectTypeNames.local_cache_SettlementType"
                :disabled="item.lock"
                :default-multiple-value="
                  item.multiple === 1 ? item.itemValue : []
                "
                :default-value="item.multiple === 1 ? '' : item.itemValue"
                :multiple="item.multiple == 1"
                filterable
                options-width="450px"
                :headers="item.headers || []"
                :fields="item.fields || []"
                :tag-name="item.tagName"
                :tag-value="item.tagValue"
                :placeholder="emptyPlaceholder"
                @enter="onAdvSelectEnter"
                @parentCallBack="getValueFromChild"
              />
              <!--合作伙伴-->
              <template v-if="item.itemType === 'company'">
                <cargo-advance-select
                  v-if="item.fieldType === 'FIELD_CUSTOMER_BROKER'"
                  :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{ customsBroker: true, officeIds: item.subType ? item.subType.officeIds || null : null, includeAllOffice: item.subType && item.subType.includeAllOffice }"
                  :hand-trigger-value="$store.getters.currentOfficeUuid"
                  :clear-not-match="true"
                  filterable
                  :disabled="item.lock"
                  :callback-params="{
                    refCode: item.itemName,
                    fieldType: item.fieldType
                  }"
                  :default-value="item.itemValue"
                  :tag-value="
                    item.tagValue !== '' ? item.tagValue : item.subType.tagValue
                  "
                  options-width="300px"
                  :headers="item.headers || []"
                  :fields="item.fields || []"
                  :tag-name="item.tagName"
                  :placeholder="emptyPlaceholder"
                  @enter="onAdvSelectEnter"
                  @parentCallBack="getValueFromChild"
                />
                <template v-else-if="(item.subType && item.subType.useSales) || (item.subType && item.subType.useSalesCsr && accountObjectControlMode === 2)">
                  <cargo-sales-company-select
                    v-if="item.defaultConditionVal === 'IN' || item.defaultConditionVal === 'NOT IN'"
                    key="sales-company-multiple"
                    :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                    :method-params="companyMethodParamFilter(item)"
                    :clear-not-match="true"
                    :disabled="item.lock"
                    :contains-no-customer="item.subType.containsNoCustomer"
                    :callback-params="{
                      refCode: item.itemName,
                      fieldType: item.fieldType
                    }"
                    :default-multiple-value="item.itemValue instanceof Array ? item.itemValue : []"
                    :multiple="true"
                    :tag-value="
                      item.tagValue !== '' ? item.tagValue : item.subType.tagValue
                    "
                    :headers="item.headers || []"
                    :fields="item.fields || []"
                    :tag-name="item.tagName"
                    :placeholder="emptyPlaceholder"
                    :use-account-object-control-mode="item.subType.useAccountObjectControlMode"
                    @enter="onAdvSelectEnter"
                    @parentCallBack="getValueFromChild"
                  />
                  <cargo-sales-company-select
                    v-else
                    key="sales-company-single"
                    :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                    :method-params="companyMethodParamFilter(item)"
                    :clear-not-match="true"
                    :disabled="item.lock"
                    :contains-no-customer="item.subType.containsNoCustomer"
                    :callback-params="{
                      refCode: item.itemName,
                      fieldType: item.fieldType
                    }"
                    :default-value="item.itemValue instanceof Array ? '' : item.itemValue"
                    :tag-value="
                      item.tagValue !== '' ? item.tagValue : item.subType.tagValue
                    "
                    :headers="item.headers || []"
                    :fields="item.fields || []"
                    :tag-name="item.tagName"
                    :placeholder="emptyPlaceholder"
                    :use-account-object-control-mode="item.subType.useAccountObjectControlMode"
                    @enter="onAdvSelectEnter"
                    @parentCallBack="getValueFromChild"
                  />
                </template>
                <template v-else>
                  <cargo-advance-select
                    v-if="item.defaultConditionVal === 'IN' || item.defaultConditionVal === 'NOT IN'"
                    key="company-multiple"
                    :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                    :select-type="selectTypeNames.basic_data_Company"
                    :method-params="companyMethodParamFilter(item)"
                    :hand-trigger-value="$store.getters.currentOfficeUuid"
                    :clear-not-match="true"
                    filterable
                    :disabled="item.lock"
                    :callback-params="{
                      refCode: item.itemName,
                      fieldType: item.fieldType
                    }"
                    :default-multiple-value="item.itemValue instanceof Array ? item.itemValue : []"
                    :multiple="true"
                    :tag-value="
                      item.tagValue !== '' ? item.tagValue : item.subType.tagValue
                    "
                    options-width="300px"
                    :headers="item.headers || []"
                    :fields="item.fields || []"
                    :tag-name="item.tagName"
                    :placeholder="emptyPlaceholder"
                    @enter="onAdvSelectEnter"
                    @parentCallBack="getValueFromChild"
                  />
                  <cargo-advance-select
                    v-else
                    key="company-single"
                    :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                    :select-type="selectTypeNames.basic_data_Company"
                    :method-params="companyMethodParamFilter(item)"
                    :hand-trigger-value="$store.getters.currentOfficeUuid"
                    :clear-not-match="true"
                    filterable
                    :disabled="item.lock"
                    :callback-params="{
                      refCode: item.itemName,
                      fieldType: item.fieldType
                    }"
                    :default-value="item.itemValue instanceof Array ? '' : item.itemValue"
                    :tag-value="
                      item.tagValue !== '' ? item.tagValue : item.subType.tagValue
                    "
                    options-width="300px"
                    :headers="item.headers || []"
                    :fields="item.fields || []"
                    :tag-name="item.tagName"
                    :placeholder="emptyPlaceholder"
                    @enter="onAdvSelectEnter"
                    @parentCallBack="getValueFromChild"
                  />
                </template>
              </template>
              <!--邮编-->
              <cargo-post-code-select
                v-if="item.itemType === 'postCode'"
                :default-value="item.itemValue"
                @change="p=> item.itemValue = p ? p.uuid : ''"
              />
              <!-- 铁路站点 -->
              <cargo-advance-select
                v-if="item.itemType === 'railwayStation'"
                :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                :select-type="selectTypeNames.basic_data_RailwayStation"
                filterable
                :disabled="item.lock"
                :callback-params="{ refCode: item.itemName }"
                :default-value="item.itemValue"
                options-width="300px"
                :headers="item.headers || []"
                :fields="item.fields || []"
                :tag-name="item.tagName"
                :tag-value="item.tagValue"
                :placeholder="emptyPlaceholder"
                @enter="onAdvSelectEnter"
                @parentCallBack="getValueFromChild"
              />
              <!--币种-->
              <template v-if="item.itemType === 'currency'">
                <cargo-advance-select
                  v-if="item.defaultConditionVal === 'IN' || item.defaultConditionVal === 'NOT IN'"
                  key="currency-multiple"
                  :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                  :select-type="selectTypeNames.basic_data_Currency"
                  :callback-params="{ refCode: item.itemName }"
                  url=""
                  filterable
                  :multiple="true"
                  :disabled="item.lock"
                  :default-multiple-value="item.itemValue instanceof Array ? item.itemValue : []"
                  options-width="200px"
                  :headers="item.headers || []"
                  :fields="item.fields || []"
                  :tag-name="item.tagName"
                  :tag-value="item.tagValue"
                  :placeholder="emptyPlaceholder"
                  @enter="onAdvSelectEnter"
                  @parentCallBack="getValueFromChild"
                />
                <cargo-advance-select
                  v-else
                  key="currency-single"
                  :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                  :select-type="selectTypeNames.basic_data_Currency"
                  :callback-params="{ refCode: item.itemName }"
                  url=""
                  filterable
                  :multiple="item.multiple === 1"
                  :disabled="item.lock"
                  :default-multiple-value="item.itemValue instanceof Array ? item.itemValue : []"
                  :default-value="item.itemValue instanceof Array ? '' : item.itemValue"
                  options-width="200px"
                  :headers="item.headers || []"
                  :fields="item.fields || []"
                  :tag-name="item.tagName"
                  :tag-value="item.tagValue"
                  :placeholder="emptyPlaceholder"
                  @enter="onAdvSelectEnter"
                  @parentCallBack="getValueFromChild"
                />
              </template>
              <!--贸易条款-->
              <template v-if="item.itemType === 'incoTerm'">
                <cargo-advance-select
                  v-if="item.defaultConditionVal === 'IN' || item.defaultConditionVal === 'NOT IN'"
                  key="incoTerm-multiple"
                  :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                  :select-type="selectTypeNames.basic_data_IncoTerm"
                  :callback-params="{ refCode: item.itemName }"
                  url=""
                  filterable
                  :multiple="true"
                  :disabled="item.lock"
                  :default-multiple-value="
                    item.multiple === 1 ? item.itemValue : []
                  "
                  :default-value="item.multiple === 1 ? '' : item.itemValue"
                  options-width="200px"
                  :headers="item.headers || []"
                  :fields="item.fields || []"
                  :tag-name="item.tagName"
                  :tag-value="item.tagValue"
                  :placeholder="emptyPlaceholder"
                  @enter="onAdvSelectEnter"
                  @parentCallBack="getValueFromChild"
                />
                <cargo-advance-select
                  v-else
                  key="incoTerm-single"
                  :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                  :select-type="selectTypeNames.basic_data_IncoTerm"
                  :callback-params="{ refCode: item.itemName }"
                  url=""
                  filterable
                  :multiple="false"
                  :disabled="item.lock"
                  :default-multiple-value="
                    item.multiple === 1 ? item.itemValue : []
                  "
                  :default-value="item.multiple === 1 ? '' : item.itemValue"
                  options-width="200px"
                  :headers="item.headers || []"
                  :fields="item.fields || []"
                  :tag-name="item.tagName"
                  :tag-value="item.tagValue"
                  :placeholder="emptyPlaceholder"
                  @enter="onAdvSelectEnter"
                  @parentCallBack="getValueFromChild"
                />
              </template>

              <!--运输条款-->
              <cargo-advance-select
                v-if="item.itemType === 'shippingTerm'"
                :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                :select-type="selectTypeNames.basic_data_ShippingTerm"
                :callback-params="{ refCode: item.itemName }"
                url=""
                filterable
                :multiple="item.multiple === 1"
                :disabled="item.lock"
                :default-multiple-value="
                  item.multiple === 1 ? item.itemValue : []
                "
                :default-value="item.multiple === 1 ? '' : item.itemValue"
                options-width="200px"
                :headers="item.headers || []"
                :fields="item.fields || []"
                :tag-name="item.tagName"
                :tag-value="item.tagValue"
                :placeholder="emptyPlaceholder"
                @enter="onAdvSelectEnter"
                @parentCallBack="getValueFromChild"
              />
              <!--产品服务-->
              <cargo-advance-select
                v-if="item.itemType === 'serviceProduct'"
                :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                :select-type="selectTypeNames.basic_data_AirServiceProduct"
                :callback-params="{ refCode: item.itemName }"
                url=""
                filterable
                :multiple="item.multiple === 1"
                :disabled="item.lock"
                :default-multiple-value="
                  item.multiple === 1 ? item.itemValue : []
                "
                :default-value="item.multiple === 1 ? '' : item.itemValue"
                options-width="200px"
                :headers="item.headers || []"
                :fields="item.fields || []"
                :tag-name="item.tagName"
                :tag-value="item.tagValue"
                :placeholder="emptyPlaceholder"
                @enter="onAdvSelectEnter"
                @parentCallBack="getValueFromChild"
              />
              <!--提单类型-->
              <cargo-advance-select
                v-if="item.itemType === 'orderFormType'"
                :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                :select-type="selectTypeNames.basic_data_OrderFormType"
                :callback-params="{ refCode: item.itemName }"
                url=""
                filterable
                :multiple="item.multiple === 1"
                :disabled="item.lock"
                :default-value="item.itemValue"
                options-width="200px"
                :headers="item.headers || []"
                :fields="item.fields || []"
                :tag-name="item.tagName"
                :tag-value="item.tagValue"
                :placeholder="emptyPlaceholder"
                @enter="onAdvSelectEnter"
                @parentCallBack="getValueFromChild"
              />
              <!--公司-->
              <template v-if="item.itemType === 'office'">
                <office-with-child-select
                  v-if="item.subType && item.subType.includeChildOffice"
                  :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                  :callback-params="{ refCode: item.itemName }"
                  :default-value="item.itemValue"
                  :headers="item.headers || []"
                  :fields="item.fields || []"
                  :tag-name="item.tagName"
                  :tag-value="item.tagValue"
                  :placeholder="emptyPlaceholder"
                  @enter="onAdvSelectEnter"
                  @parentCallBack="getValueFromChild"
                />
                <cargo-advance-select
                  v-else
                  :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                  filterable
                  :callback-params="{ refCode: item.itemName }"
                  :select-type="item.subType && item.subType.includeAllOffice ? selectTypeNames.basic_data_Office_All : selectTypeNames.basic_data_Office"
                  :default-value="item.multiple === 1 ? '' : item.itemValue"
                  :method-params="{}"
                  :headers="item.headers || []"
                  :fields="item.fields || []"
                  :tag-name="item.tagName"
                  :tag-value="item.tagValue"
                  :placeholder="emptyPlaceholder"
                  :multiple="item.multiple === 1"
                  :default-multiple-value="item.multiple === 1 ? item.itemValue : []"
                  @enter="onAdvSelectEnter"
                  @parentCallBack="getValueFromChild"
                />
              </template>
              <!--所属分公司-->
              <cargo-owned-branch-select
                v-if="item.itemType === 'autoOffice'"
                :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                v-model="item.itemValue"
                :multiple="item.multiple === 1"
                :clearable="true"
                :placeholder="emptyPlaceholder"
              />
              <!--部门-->
              <cargo-advance-select
                v-if="item.itemType === 'department'"
                :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                :disabled="item.lock"
                :select-type="selectTypeNames.basic_data_Department"
                :method-params="{
                  officeUuid: $store.getters.currentOfficeUuid
                }"
                :clear-not-match="true"
                filterable
                :placeholder="emptyPlaceholder"
                :multiple="item.multiple === 1"
                :callback-params="{ refCode: item.itemName }"
                :default-multiple-value="
                  item.multiple === 1 ? item.itemValue : []
                "
                :default-value="item.multiple === 1 ? '' : item.itemValue"
                :headers="item.headers || []"
                :fields="item.fields || []"
                :tag-name="item.tagName"
                :tag-value="item.tagValue"
                @enter="onAdvSelectEnter"
                @parentCallBack="getValueFromChild"
              />
              <!--todo 权限管理已维护的部门中，勾选是结算公司的部门-->
              <cargo-advance-select
                v-if="item.itemType === 'department2'"
                :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                :disabled="item.lock"
                :select-type="selectTypeNames.basic_data_Department_All"
                :method-params="{
                  officeUuid: $store.getters.currentOfficeUuid,
                  clearing:true
                }"
                :clear-not-match="true"
                filterable
                :placeholder="emptyPlaceholder"
                :multiple="item.multiple === 1"
                :callback-params="{ refCode: item.itemName }"
                :default-multiple-value="
                  item.multiple === 1 ? item.itemValue : []
                "
                :default-value="item.multiple === 1 ? '' : item.itemValue"
                :headers="item.headers || []"
                :fields="item.fields || []"
                :tag-name="item.tagName"
                :tag-value="item.tagValue"
                @enter="onAdvSelectEnter"
                @parentCallBack="getValueFromChild"
              />
              <!--todo 公司部门-包含子部门 下的所有部门-->
              <cargo-advance-select
                v-if="item.itemType === 'department3'"
                :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                :disabled="item.lock"
                :select-type="
                  selectTypeNames.basic_data_OfficeDepartmentAllDepartmentMap
                "
                :method-params="{ officeId: $store.getters.currentOfficeId }"
                :clear-not-match="true"
                filterable
                :multiple="item.multiple === 1"
                :callback-params="{ refCode: item.itemName }"
                :default-multiple-value="item.itemValue"
                :headers="item.headers || []"
                :fields="item.fields || []"
                :tag-name="item.tagName"
                :tag-value="item.tagValue"
                :placeholder="emptyPlaceholder"
                @enter="onAdvSelectEnter"
                @parentCallBack="getValueFromChild"
              />
              <!--公司子公司 下的所有部门-->
              <cargo-advance-select
                v-if="item.itemType === 'department4'"
                :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                :disabled="item.lock"
                :select-type="selectTypeNames.basic_data_OfficeAllDepartmentMap"
                :method-params="{ officeId: $store.getters.currentOfficeId }"
                :clear-not-match="true"
                filterable
                :multiple="item.multiple === 1"
                :callback-params="{ refCode: item.itemName }"
                :default-multiple-value="item.multiple === 1 ? item.itemValue : []"
                :default-value="item.multiple === 1 ? '' : item.itemValue"
                :headers="item.headers || []"
                :fields="item.fields || []"
                :tag-name="item.tagName"
                :tag-value="item.tagValue"
                :placeholder="emptyPlaceholder"
                @enter="onAdvSelectEnter"
                @parentCallBack="getValueFromChild"
              />
              <!--当前公司下的所有部门-->
              <cargo-advance-select
                v-if="item.itemType === 'department5'"
                :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                :disabled="item.lock"
                :select-type="selectTypeNames.basic_data_Department_All"
                :method-params="item.subType && item.subType.includeAllOffice ? {} : { officeUuid: $store.getters.currentOfficeUuid }"
                :clear-not-match="true"
                filterable
                :placeholder="emptyPlaceholder"
                :multiple="item.multiple === 1"
                :callback-params="{ refCode: item.itemName }"
                :default-multiple-value="
                  item.multiple === 1 ? item.itemValue : []
                "
                :default-value="item.multiple === 1 ? '' : item.itemValue"
                :headers="item.headers || []"
                :fields="item.fields || []"
                :tag-name="item.tagName"
                :tag-value="item.tagValue"
                @enter="onAdvSelectEnter"
                @parentCallBack="getValueFromChild"
              />
              <!-- 航线,支持单选多选 -->
              <template v-if="item.itemType === 'region'">
                <cargo-advance-select
                  v-if="item.defaultConditionVal === AdvancedSearchConsts.OPERATOR_IN.code"
                  :key="`region-m-${item.itemName}-${item.defaultConditionVal}-${selectedConfigValue}`"
                  :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                  :disabled="item.lock"
                  :select-type="selectTypeNames.basic_data_Region"
                  filterable
                  :multiple="true"
                  :callback-params="{ refCode: item.itemName, itemType: 'region' }"
                  :default-multiple-value="item.itemValue instanceof Array ? item.itemValue : []"
                  :headers="item.headers || []"
                  :fields="item.fields || []"
                  :tag-name="item.tagName"
                  :tag-value="item.tagValue"
                  :placeholder="emptyPlaceholder"
                  @enter="onAdvSelectEnter"
                  @parentCallBack="getValueFromChild"
                />
                <cargo-advance-select
                  v-else
                  :key="`region-s-${item.itemName}-${item.defaultConditionVal}-${selectedConfigValue}`"
                  :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                  :disabled="item.lock"
                  :select-type="selectTypeNames.basic_data_Region"
                  filterable
                  :multiple="false"
                  :callback-params="{ refCode: item.itemName, itemType: 'region' }"
                  :default-multiple-value="[]"
                  :default-value="item.itemValue instanceof Array ? (item.itemValue[0] || '') : item.itemValue"
                  :headers="item.headers || []"
                  :fields="item.fields || []"
                  :tag-name="item.tagName"
                  :tag-value="item.tagValue"
                  :placeholder="emptyPlaceholder"
                  @enter="onAdvSelectEnter"
                  @parentCallBack="getValueFromChild"
                />
              </template>
              <!-- 提单方式 -->
              <cargo-advance-select
                v-if="item.itemType === 'blMode'"
                :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                :disabled="item.lock"
                :select-type="selectTypeNames.basic_data_BlMode"
                :method-params="item.subType"
                filterable
                :callback-params="{ refCode: item.itemName }"
                :default-multiple-value="
                  item.multiple === 1 ? item.itemValue : []
                "
                :default-value="item.multiple === 1 ? '' : item.itemValue"
                :headers="item.headers || []"
                :fields="item.fields || []"
                :tag-name="item.tagName"
                :tag-value="item.tagValue"
                :placeholder="emptyPlaceholder"
                @enter="onAdvSelectEnter"
                @parentCallBack="getValueFromChild"
              />
              <!-- 自定义业务类型 -->
              <template v-if="item.itemType === 'cutomJobType'">
                <cargo-cascader
                  v-if="item.subType === 'cascader'"
                  :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                  v-model="item.itemValue"
                  :disabled="item.lock"
                  :select-type="selectTypeNames.basic_data_CutomJobType"
                  filterable
                  group-field="type"
                  :railway-common-data-source="false"
                  :group-label-map="{SE:$t('CargoMsg.Cargo_OceanExport'),SI:$t('CargoMsg.Cargo_OceanImport'),AE:$t('CargoMsg.Cargo_AirExport'),AI:$t('CargoMsg.Cargo_AirImport'),RE:$t('CargoMsg.Cargo_RailwayExport'),RI:$t('CargoMsg.Cargo_RailwayImport'),IE:$t('CargoMsg.Cargo_IntegratedJob')}"
                  :tag-name="item.tagName"
                  :tag-value="item.tagValue"
                  :placeholder="emptyPlaceholder"
                  @enter="onAdvSelectEnter"
                />
                <cargo-cascader
                  v-else-if="item.subType === 'RE'"
                  :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                  v-model="item.itemValue"
                  :disabled="item.lock"
                  :select-type="selectTypeNames.basic_data_CutomJobType"
                  filterable
                  group-field="type"
                  :filter-null-key="true"
                  :railway-common-data-source="false"
                  :group-label-map="{RE:$t('CargoMsg.Cargo_RailwayExport'),RI:$t('CargoMsg.Cargo_RailwayImport')}"
                  :tag-name="item.tagName"
                  :tag-value="item.tagValue"
                  :placeholder="emptyPlaceholder"
                  @enter="onAdvSelectEnter"
                />
                <template v-else>
                  <cargo-advance-select
                    v-if="item.defaultConditionVal === 'IN'"
                    key="cutomJobType-multiple"
                    :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                    :disabled="item.lock"
                    :select-type="selectTypeNames.basic_data_CutomJobType"
                    filterable
                    :method-params="item.subType"
                    :callback-params="{ refCode: item.itemName }"
                    :default-multiple-value="item.itemValue instanceof Array ? item.itemValue : []"
                    :multiple="true"
                    :headers="item.headers || []"
                    :fields="item.fields || []"
                    :tag-name="item.tagName"
                    :tag-value="item.tagValue"
                    :placeholder="emptyPlaceholder"
                    @enter="onAdvSelectEnter"
                    @parentCallBack="getValueFromChild"
                  />
                  <cargo-advance-select
                    v-else
                    key="cutomJobType-single"
                    :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                    :disabled="item.lock"
                    :select-type="selectTypeNames.basic_data_CutomJobType"
                    :method-params="item.subType"
                    filterable
                    :callback-params="{ refCode: item.itemName }"
                    :default-value="item.itemValue"
                    :headers="item.headers || []"
                    :fields="item.fields || []"
                    :tag-name="item.tagName"
                    :tag-value="item.tagValue"
                    :placeholder="emptyPlaceholder"
                    @enter="onAdvSelectEnter"
                    @parentCallBack="getValueFromChild"
                  />
                </template>
              </template>
              <!-- 客户类型 -->
              <cargo-advance-select
                v-if="item.itemType === 'customerType'"
                :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                :disabled="item.lock"
                :select-type="selectTypeNames.basic_data_CustomerType"
                filterable
                :callback-params="{ refCode: item.itemName }"
                :default-value="item.itemValue"
                :headers="item.headers || []"
                :fields="item.fields || []"
                :tag-name="item.tagName"
                :tag-value="item.tagValue"
                :placeholder="emptyPlaceholder"
                @enter="onAdvSelectEnter"
                @parentCallBack="getValueFromChild"
              />
              <!-- 运费条款 -->
              <template v-if="item.itemType === 'paymentTerm'">
                <cargo-advance-select
                  v-if="item.defaultConditionVal === 'IN' || item.defaultConditionVal === 'NOT IN'"
                  key="payment-term-multiple"
                  :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                  :disabled="item.lock"
                  :select-type="selectTypeNames.basic_data_PaymentTerm"
                  :custom-label="paymentTermOptionLabel"
                  filterable
                  :multiple="true"
                  :callback-params="{ refCode: item.itemName }"
                  :default-multiple-value="item.itemValue instanceof Array ? item.itemValue : []"
                  :headers="item.headers || []"
                  :fields="item.fields || []"
                  :tag-name="item.tagName"
                  :tag-value="item.tagValue"
                  :placeholder="emptyPlaceholder"
                  @enter="onAdvSelectEnter"
                  @parentCallBack="getValueFromChild"
                />
                <cargo-advance-select
                  v-else
                  key="payment-term-single"
                  :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                  :disabled="item.lock"
                  :select-type="selectTypeNames.basic_data_PaymentTerm"
                  :custom-label="paymentTermOptionLabel"
                  filterable
                  :callback-params="{ refCode: item.itemName }"
                  :default-value="item.itemValue instanceof Array ? '' : item.itemValue"
                  :headers="item.headers || []"
                  :fields="item.fields || []"
                  :tag-name="item.tagName"
                  :tag-value="item.tagValue"
                  :placeholder="emptyPlaceholder"
                  @enter="onAdvSelectEnter"
                  @parentCallBack="getValueFromChild"
                />
              </template>
              <!-- 货物类型 -->
              <template v-if="item.itemType === 'cargoType'">
                <cargo-advance-select
                  v-if="item.fieldType === 'FIELD_SEA_CARGOTYPE'"
                  :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                  :disabled="item.lock"
                  :select-type="selectTypeNames.basic_data_CargoType"
                  filterable
                  :callback-params="{ refCode: item.itemName }"
                  :default-value="item.itemValue"
                  :headers="item.headers || []"
                  :fields="item.fields || []"
                  :tag-name="item.tagName"
                  :tag-value="item.tagValue"
                  :placeholder="emptyPlaceholder"
                  @enter="onAdvSelectEnter"
                  @parentCallBack="getValueFromChild"
                />
                <cargo-advance-select
                  v-if="item.fieldType === 'FIELD_MULTI_DROP_DOWN_LIST'"
                  :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                  :disabled="item.lock"
                  :select-type="selectTypeNames.basic_data_CargoType"
                  filterable
                  :callback-params="{ refCode: item.itemName }"
                  :default-multiple-value="item.itemValue instanceof Array ? item.itemValue : []"
                  :multiple="true"
                  :headers="item.headers || []"
                  :fields="item.fields || []"
                  :tag-name="item.tagName"
                  :tag-value="item.tagValue"
                  :placeholder="emptyPlaceholder"
                  @enter="onAdvSelectEnter"
                  @parentCallBack="getValueFromChild"
                />
              </template>
              <template v-if="item.itemType === 'cargoTerminalOperation'">
                <cargo-advance-select
                  v-if="item.defaultConditionVal === 'IN' || item.defaultConditionVal === 'NOT IN'"
                  key="cargo-terminal-operation-multiple"
                  :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                  :select-type="selectTypeNames.basic_data_AirportCargoTerminal"
                  :callback-params="{ refCode: item.itemName }"
                  url=""
                  filterable
                  :multiple="true"
                  :disabled="item.lock"
                  :method-params="item.subType"
                  :default-multiple-value="item.itemValue instanceof Array ? item.itemValue : []"
                  options-width="200px"
                  :headers="item.headers || []"
                  :fields="item.fields || []"
                  :tag-name="item.tagName"
                  :tag-value="item.tagValue"
                  :placeholder="emptyPlaceholder"
                  @enter="onAdvSelectEnter"
                  @parentCallBack="getValueFromChild"
                />
                <cargo-advance-select
                  v-else
                  key="cargo-terminal-operation-single"
                  :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                  :select-type="selectTypeNames.basic_data_AirportCargoTerminal"
                  :callback-params="{ refCode: item.itemName }"
                  url=""
                  filterable
                  :multiple="item.multiple === 1"
                  :disabled="item.lock"
                  :method-params="item.subType"
                  :default-multiple-value="item.itemValue instanceof Array ? item.itemValue : []"
                  :default-value="item.itemValue instanceof Array ? '' : item.itemValue"
                  options-width="200px"
                  :headers="item.headers || []"
                  :fields="item.fields || []"
                  :tag-name="item.tagName"
                  :tag-value="item.tagValue"
                  :placeholder="emptyPlaceholder"
                  @enter="onAdvSelectEnter"
                  @parentCallBack="getValueFromChild"
                />
              </template>
              <!-- 贸易方式 -->
              <cargo-advance-select
                v-if="item.itemType === 'tradeTerm'"
                :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                :disabled="item.lock"
                :select-type="selectTypeNames.basic_data_TradeTerm"
                filterable
                :callback-params="{ refCode: item.itemName }"
                :default-value="item.itemValue"
                :headers="item.headers || []"
                :fields="item.fields || []"
                :tag-name="item.tagName"
                :tag-value="item.tagValue"
                :placeholder="emptyPlaceholder"
                @enter="onAdvSelectEnter"
                @parentCallBack="getValueFromChild"
              />
              <template v-if="item.itemType === 'fileType'">
                <cargo-cascader
                  v-if="item.subType === 'cascader'"
                  :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                  v-model="item.itemValue"
                  :disabled="item.lock"
                  :static-options="item.dataProvider"
                  filterable
                  group-field="ifFba"
                  :tag-name="item.tagName"
                  :tag-value="item.tagValue"
                  :placeholder="emptyPlaceholder"
                  @enter="onAdvSelectEnter"
                />
              </template>
              <!-- 海外仓 -->
              <template v-if="item.itemType === 'overseaWarehouse'">
                <cargo-cascader
                  v-if="item.subType === 'cascader'"
                  :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                  v-model="item.itemValue"
                  :disabled="item.lock"
                  :select-type="selectTypeNames.basic_data_OverseaWarehouse"
                  filterable
                  group-field="ifFba"
                  :group-label-map="{true:'FBA',false:$t('FbaJob.otherOverseaWarehouse')}"
                  :tag-name="item.tagName"
                  :tag-value="item.tagValue"
                  :placeholder="emptyPlaceholder"
                  @enter="onAdvSelectEnter"
                />
                <template v-else>
                  <cargo-advance-select
                    v-if="item.defaultConditionVal === 'IN' || item.defaultConditionVal === 'NOT IN'"
                    :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                    :disabled="item.lock"
                    :select-type="selectTypeNames.basic_data_OverseaWarehouse"
                    filterable
                    :method-params="item.subType"
                    :callback-params="{ refCode: item.itemName }"
                    :default-multiple-value="item.itemValue instanceof Array ? item.itemValue : []"
                    :multiple="true"
                    :headers="item.headers || []"
                    :fields="item.fields || []"
                    :tag-name="item.tagName"
                    :tag-value="item.tagValue"
                    :placeholder="emptyPlaceholder"
                    @enter="onAdvSelectEnter"
                    @parentCallBack="getValueFromChild"
                  />
                  <cargo-advance-select
                    v-else-if="'BATCH' !== item.defaultConditionVal"
                    :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                    :disabled="item.lock"
                    :select-type="selectTypeNames.basic_data_OverseaWarehouse"
                    filterable
                    :method-params="item.subType"
                    :callback-params="{ refCode: item.itemName }"
                    :default-value="item.itemValue instanceof Array ? '' : item.itemValue"
                    :headers="item.headers || []"
                    :fields="item.fields || []"
                    :tag-name="item.tagName"
                    :tag-value="item.tagValue"
                    :placeholder="emptyPlaceholder"
                    @enter="onAdvSelectEnter"
                    @parentCallBack="getValueFromChild"
                  />
                </template>
              </template>
              <!-- FBA渠道 -->
              <cargo-advance-select
                v-if="item.itemType === 'fbaChannel'"
                :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                :disabled="item.lock"
                :select-type="selectTypeNames.basic_data_FbaChannel"
                filterable
                :method-params="item.subType"
                :callback-params="{ refCode: item.itemName }"
                :default-value="item.itemValue"
                :headers="item.headers || []"
                :fields="item.fields || []"
                :tag-name="item.tagName"
                :tag-value="item.tagValue"
                :placeholder="emptyPlaceholder"
                @enter="onAdvSelectEnter"
                @parentCallBack="getValueFromChild"
              />
              <!-- FBA渠道 -->
              <cargo-advance-select
                v-if="item.itemType === 'fbaChannel'"
                :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                :disabled="item.lock"
                :select-type="selectTypeNames.basic_data_FbaChannel"
                filterable
                :method-params="item.subType"
                :callback-params="{ refCode: item.itemName }"
                :default-value="item.itemValue"
                :headers="item.headers || []"
                :fields="item.fields || []"
                :tag-name="item.tagName"
                :tag-value="item.tagValue"
                :placeholder="emptyPlaceholder"
                @enter="onAdvSelectEnter"
                @parentCallBack="getValueFromChild"
              />
              <!-- 增值服务 -->
              <cargo-advance-select
                v-if="item.itemType === 'valueAddedService'"
                :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                :disabled="item.lock"
                :select-type="selectTypeNames.basic_data_ValueAddedService"
                :multiple="item.multiple === 1"
                :default-multiple-value="
                  item.multiple === 1 ? item.itemValue : []
                "
                filterable
                :method-params="item.subType"
                :callback-params="{ refCode: item.itemName }"
                :default-value="item.itemValue"
                :headers="item.headers || []"
                :fields="item.fields || []"
                :tag-name="item.tagName"
                :tag-value="item.tagValue"
                :placeholder="emptyPlaceholder"
                @enter="onAdvSelectEnter"
                @parentCallBack="getValueFromChild"
              />
              <!-- 客户来源 -->
              <cargo-advance-select
                v-if="item.itemType === 'customerSource'"
                :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                :select-type="selectTypeNames.basic_data_CustomerSource"
                filterable
                :disabled="item.lock"
                :callback-params="{ refCode: item.itemName }"
                :default-value="item.itemValue"
                :headers="item.headers || []"
                :fields="item.fields || []"
                :tag-name="item.tagName"
                :tag-value="item.tagValue"
                :placeholder="emptyPlaceholder"
                @enter="onAdvSelectEnter"
                @parentCallBack="getValueFromChild"
              />
              <!-- 客户来源 -->
              <cargo-advance-select
                v-if="item.itemType === 'customerSource2'"
                :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                :select-type="selectTypeNames.basic_data_CustomerSource"
                filterable
                :disabled="item.lock"
                :multiple="item.multiple === 1"
                :callback-params="{ refCode: item.itemName }"
                :default-multiple-value="item.itemValue instanceof Array ? item.itemValue : []"
                :default-value="item.multiple === 1 ? '' : item.itemValue"
                :headers="item.headers || []"
                :fields="item.fields || []"
                :tag-name="item.tagName"
                :tag-value="item.tagValue"
                :placeholder="emptyPlaceholder"
                :custom-label="(p)=>`${p.name}`"
                @enter="onAdvSelectEnter"
                @parentCallBack="getValueFromChild"
              />
              <!-- 运输类型 -->
              <cargo-advance-select
                v-if="item.itemType === 'transportType'"
                :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                :select-type="selectTypeNames.basic_data_TransportType"
                filterable
                :disabled="item.lock"
                :callback-params="{ refCode: item.itemName }"
                :default-value="item.itemValue"
                :headers="item.headers || []"
                :fields="item.fields || []"
                :tag-name="item.tagName"
                :tag-value="item.tagValue"
                :placeholder="emptyPlaceholder"
                @enter="onAdvSelectEnter"
                @parentCallBack="getValueFromChild"
              />
              <!-- 项目名称 -->
              <cargo-project-name-select
                v-if="item.itemType === 'projectName'"
                :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                v-model="item.itemValue"
                :disabled="item.lock"
                :placeholder="emptyPlaceholder"
              />
              <!-- 业务状态-->
              <cargo-advance-select
                v-else-if="item.multiple === 1 && !!item.dropdownDataRef && item.dataCacheKey && item.dataCacheKey === 'local_cache_SystemConstants$JOB_STATES'"
                :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                :disabled="item.lock"
                :select-type="selectTypeNames[item.dataCacheKey]"
                :static-options="[...JOB_STATES]"
                filterable
                :callback-params="{
                  refCode: item.itemName,
                  fieldType: item.fieldType
                }"
                :default-multiple-value="handleJobStates(item)"
                multiple
                :placeholder="emptyPlaceholder"
                options-width="450px"
                :headers="item.headers || []"
                :fields="item.fields || []"
                :tag-name="item.tagName"
                :tag-value="item.tagValue"
                @enter="onAdvSelectEnter"
                @parentCallBack="getValueFromChild"
              />
              <!-- ****注：下述通用处理方式，是在上面具体项中没找到匹配项时，进行使用-->
              <!-- todo 可将v-if替换为v-else-if,需测试-->
              <!-- todo 基本数据缓存-->
              <!-- todo 本地常量缓存-->
              <cargo-advance-select
                v-else-if="item.multiple == 1 && !!item.dropdownDataRef"
                :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                :disabled="item.lock"
                :select-type="selectTypeNames[item.dataCacheKey]"
                filterable
                :callback-params="{
                  refCode: item.itemName,
                  fieldType: item.fieldType
                }"
                :default-multiple-value="item.itemValue"
                multiple
                :placeholder="emptyPlaceholder"
                options-width="450px"
                :headers="item.headers || []"
                :fields="item.fields || []"
                :tag-name="item.tagName"
                :tag-value="item.tagValue"
                @enter="onAdvSelectEnter"
                @parentCallBack="getValueFromChild"
              />
              <cargo-advance-select
                v-else-if="item.multiple != 1 && !!item.dropdownDataRef"
                :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                :disabled="item.lock"
                :select-type="selectTypeNames[item.dataCacheKey]"
                filterable
                :callback-params="{
                  refCode: item.itemName,
                  fieldType: item.fieldType
                }"
                :default-value="item.itemValue"
                options-width="450px"
                :placeholder="emptyPlaceholder"
                :headers="item.headers || []"
                :fields="item.fields || []"
                :tag-name="item.tagName"
                :tag-value="item.tagValue"
                @enter="onAdvSelectEnter"
                @parentCallBack="getValueFromChild"
              />
              <!--适用于查询条件的数据源需要调用后端接口或者数据源为静态变量-->
              <cargo-advance-select
                v-else-if="item.itemType === 'advanceSelect'"
                :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                filterable
                :cache="false"
                :select-type="selectTypeNames[item.dataCacheKey]"
                :disabled="item.defaultConditionVal === 'IS NULL' || item.lock"
                :headers="item.headers"
                :fields="item.fields"
                :tag-name="item.tagName"
                :tag-value="item.tagValue"
                :url="item.url"
                :method-params="item.methodParams"
                :static-options="item.valueExpression ? item.valueExpression.valueContent : []"
                :callback-params="{ refCode: item.itemName }"
                :multiple="item.multiple === 1"
                :default-multiple-value="item.multiple === 1 ? item.itemValue : []"
                :default-value="item.multiple === 1 ? '' : item.itemValue"
                :placeholder="emptyPlaceholder"
                :filter-type="item.filterType || ''"
                :page="item.subType && item.subType.page ? item.subType.page : false"
                :page-size="item.subType && item.subType.pageSize ? item.subType.pageSize : 50"
                @enter="onAdvSelectEnter"
                @parentCallBack="getValueFromChild"
              />
              <template v-if="item.itemType === 'advanceSelect2'">
                <cargo-advance-select
                  v-if="item.defaultConditionVal === 'IN' || item.defaultConditionVal === 'NOT IN'"
                  key="multiple"
                  :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                  filterable
                  :cache="false"
                  :select-type="selectTypeNames[item.dataCacheKey]"
                  :disabled="item.lock"
                  :headers="item.headers"
                  :multiple="true"
                  :fields="item.fields"
                  :filter-tag-names="item.filterTagNames"
                  :tag-name="item.tagName"
                  :tag-value="item.tagValue"
                  :url="item.url"
                  :method-params="item.methodParams"
                  :static-options="item.valueExpression ? item.valueExpression.valueContent : []"
                  :callback-params="{ refCode: item.itemName }"
                  :default-multiple-value="item.itemValue instanceof Array ? item.itemValue : []"
                  :placeholder="emptyPlaceholder"
                  :filter-type="item.filterType || ''"
                  @enter="onAdvSelectEnter"
                  @parentCallBack="getValueFromChild"
                />
                <cargo-advance-select
                  v-else
                  key="single"
                  :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                  filterable
                  :cache="false"
                  :select-type="selectTypeNames[item.dataCacheKey]"
                  :disabled="item.lock"
                  :headers="item.headers"
                  :fields="item.fields"
                  :filter-tag-names="item.filterTagNames"
                  :tag-name="item.tagName"
                  :tag-value="item.tagValue"
                  :url="item.url"
                  :method-params="item.methodParams"
                  :static-options="item.valueExpression ? item.valueExpression.valueContent : []"
                  :callback-params="{ refCode: item.itemName }"
                  :multiple="false"
                  :default-value="item.itemValue instanceof Array ? '' : item.itemValue"
                  :placeholder="emptyPlaceholder"
                  :filter-type="item.filterType || ''"
                  @enter="onAdvSelectEnter"
                  @parentCallBack="getValueFromChild"
                />
              </template>
              <!--sop模板-->
              <template v-else-if="item.itemType === 'sopTemplate'">
                <cargo-cascader-multi
                  v-if="item.subType === 'cascaderMulti'"
                  :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                  v-model="item.itemValue"
                  filterable
                  :disabled="item.lock"
                  :select-type="selectTypeNames[item.dataCacheKey]"
                  group-field="lob"
                  :group-label-map="{SE:$t('CargoMsg.Cargo_OceanExport'),SI:$t('CargoMsg.Cargo_OceanImport'),AE:$t('CargoMsg.Cargo_AirExport'),AI:$t('CargoMsg.Cargo_AirImport'),RE:$t('CargoMsg.Cargo_RailwayBusiness'),IE:$t('CargoMsg.Cargo_IntegratedJob')}"
                  tag-name="templateName"
                  tag-value="uuid"
                  :placeholder="emptyPlaceholder"
                  :copy-flag="false"
                  @enter="onAdvSelectEnter"
                />
                <cargo-advance-select
                  v-else
                  :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                  filterable
                  :cache="true"
                  :callback-params="{ refCode: item.itemName }"
                  :select-type="selectTypeNames[item.dataCacheKey]"
                  tag-name="templateName"
                  tag-value="uuid"
                  :method-params="item.methodParams"
                  :multiple="item.multiple === 1"
                  :multiple-model="item.multipleModel"
                  :default-multiple-value="item.multiple === 1 ? item.itemValue : []"
                  :default-value="item.multiple === 1 ? '' : item.itemValue"
                  :placeholder="emptyPlaceholder"
                  @enter="onAdvSelectEnter"
                  @parentCallBack="getValueFromChild"
                />
              </template>
              <cargo-hq-company-select
                v-if="item.itemType === 'hqCompany'"
                :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                filterable
                :select-type="selectTypeNames[item.dataCacheKey]"
                :callback-params="{ refCode: item.itemName, fieldType: item.fieldType }"
                :disabled="item.lock"
                :headers="item.headers"
                :fields="item.fields"
                :tag-name="item.tagName"
                :tag-value="item.tagValue"
                :method-params="item.methodParams"
                :office-id="$store.getters.currentOfficeId"
                :default-value="item.itemValue"
                :placeholder="emptyPlaceholder"
                @enter="onAdvSelectEnter"
                @parentCallBack="getValueFromChild"
              />
              <container-load-type-cascader
                v-if="item.itemType === 'containerLoadTypeCascader'"
                :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                v-model="item.itemValue"
                :all-lob="item.fieldType === 'FIELD_DROP_DOWN_LIST_ALL_LOB'"
                :disabled="item.lock"
              />
              <country-area-cascader
                v-if="item.itemType === 'countryAreaCascader'"
                :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                :value="item.itemValue instanceof Array ? item.itemValue : []"
                :disabled="item.lock"
                @input="val=>{item.itemValue=val}"
              />
              <!-- 操作要求 -->
              <template v-if="item.itemType === 'operationContent'">
                <el-input
                  :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                  :value="item.itemValue?item.itemValue.replace(/\n/g,' '):''"
                  size="mini"
                  readonly
                  :placeholder="$t('SeaExport.selectOperationRequirement') "
                  @dblclick.native="openSelectOperationDialog(item)"
                />
                <el-button
                  v-show="!!item.itemValue"
                  size="mini"
                  :disabled="item.lock"
                  @click="item.itemValue=''"
                >{{ $t('Message.Clear') }}
                </el-button>
              </template>
              <!--  特殊操作码 -->
              <template v-if="item.itemType === 'specialOperationCode'">
                <el-input
                  :ref="`${item.itemName}${item.itemType}${selectedConfigValue}`"
                  :value="item.itemValue"
                  size="mini"
                  readonly
                  :placeholder="$t('SeaExport.selectSpecialOperationCode') "
                  @dblclick.native="openSelectSpecialOperationCodeDialog(item)"
                />
                <el-button
                  v-show="!!item.itemValue"
                  size="mini"
                  :disabled="item.lock"
                  @click="item.itemValue=''"
                >{{ $t('Message.Clear') }}
                </el-button>
              </template>
              <!--自定义合作伙伴-->
              <slot
                v-if="item.itemType === 'customCompany'"
                name="customCompany"
                :item="item"
                :getValueFromChild="p=>getValueFromChild(p)"
              />
              <!--自定义类型1-->
              <slot
                v-if="item.itemType === 'customType1'"
                name="customType1"
                :item="item"
                :getValueFromChild="p=>getValueFromChild(p)"
              />
              <!--自定义类型2-->
              <slot
                v-if="item.itemType === 'customType2'"
                name="customType2"
                :item="item"
                :getValueFromChild="p=>getValueFromChild(p)"
              />
              <!-- todo 远程url获取-->
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!--方案管理-->
    <el-dialog
      no="QuerySchemeManagement"
      class="cargo-advance-search-dialog"
      :visible.sync="isShowSaveAs"
      :title="$t('CargoMsg.Cargo_QuerySchemeManagement')"
      width="630px"
      append-to-body
    >
      <el-table
        ref="multipleTable"
        class="maintain-item-table"
        border
        :data="perConfigs"
        size="mini"
        height="250"
        tooltip-effect="dark"
        highlight-current-row
        style="width: 100%"
      >
        <el-table-column
          :label="$t('CargoMsg.Cargo_SchemeName')"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.configName }}
          </template>
        </el-table-column>

        <el-table-column
          :label="$t('CargoMsg.Cargo_Default')"
          show-overflow-tooltip
        >
          <template slot-scope="scope">{{
            scope.row.bDefault ? $t('Message.Yes') : $t('Message.No')
          }}</template>
        </el-table-column>

        <el-table-column :label="$t('CargoMsg.Cargo_Operation')" width="150">
          <div slot-scope="scope" style="display: flex">
            <el-button
              v-if="!scope.row.bDefault && scope.row.configName !== 'default'"
              :no="scope.row.configName+'_1'"
              type="text"
              size="mini"
              @click.native.prevent="
                deleteRowSearchTemplate(scope.$index, perConfigs)
              "
            >
              {{ $t('CargoMsg.Cargo_Delete') }}
            </el-button>
            <el-button
              v-if="!scope.row.bDefault"
              :no="scope.row.configName+'_2'"
              type="text"
              size="mini"
              @click.native.prevent="
                setDefault(scope.$index, perConfigs)
              "
            >
              {{ $t('CargoMsg.Cargo_SetAsDefault') }}
            </el-button>
          </div>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!--增减条件-->
    <el-dialog
      no="SelectQueryCriteria"
      class="cargo-advance-search-dialog"
      :visible.sync="isShowAbc"
      :title="$t('CargoMsg.Cargo_SelectQueryCriteria')"
      width="900px"
      top="5vh"
      append-to-body
    >
      <el-input
        v-model="queryFilter"
        style="width: 49%"
        :placeholder="$t('CargoMsg.Cargo_PleaseInputKeyWordsForQuery')"
        clearable
      >
        <i slot="suffix" class="el-icon-search" />
      </el-input>
      <div
        style="overflow: hidden;display: flex;justify-content: space-between"
      >
        <div style="width: 49%;">
          <div
            style="color:#409EFF;display: flex;justify-content: space-between"
          >
            <div>
              {{ $t('CargoMsg.Cargo_AllQueryCriteria') }}【{{
                searchItems.length
              }}{{ $t('CargoMsg.Cargo_Pcs') }}】&nbsp;
            </div>
            <div style="width:183px;">
              <el-button
                slot="header"
                no="SelectAll"
                type="text"
                size="mini"
                @click="toChooseAllSearchItem"
              >{{ $t('CargoMsg.Cargo_SelectAll') }}
              </el-button>
              /
              <el-button
                slot="header"
                no="InverseSelect"
                type="text"
                size="mini"
                @click="toInvertChooseSearchItem"
              >{{ $t('CargoMsg.Cargo_InverseSelect') }}
              </el-button>
            </div>
          </div>
          <el-table
            ref="multipleTable"
            no="multipleTable"
            :data="filteredSearchItems"
            size="mini"
            height="400"
            tooltip-effect="dark"
            @selection-change="handleSelectionChange"
          >
            <!--<el-table-column-->
            <!--type="selection"-->
            <!--width="30"/>-->
            <el-table-column
              prop="itemLabel"
              label=""
              width="30"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span v-if="scope.row.selected">
                  <i style="color: #409EFF" class="el-icon-success" />
                </span>
              </template>
            </el-table-column>

            <el-table-column
              prop="itemLabel"
              :label="$t('CargoMsg.Cargo_DisplayName')"
              width="290"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ i18nAdvSearch(scope.row.itemLabel) }}
              </template>
            </el-table-column>
            <!--<el-table-column-->
            <!--prop="itemName"-->
            <!--label="代码"-->
            <!--width="95"-->
            <!--show-overflow-tooltip-->
            <!--/>-->
            <!--<el-table-column-->
            <!--label="类型"-->
            <!--width="85"-->
            <!--show-overflow-tooltip-->
            <!--&gt;-->
            <!--<template slot-scope="scope">-->
            <!--{{ scope.row.itemType }}-->
            <!--</template>-->
            <!--</el-table-column>-->
            <el-table-column :label="$t('CargoMsg.Cargo_Operation')" width="80">
              <template slot-scope="scope">
                <el-button
                  v-if="!scope.row.lock"
                  :no="scope.row.itemLabel"
                  type="text"
                  size="small"
                  icon="el-icon-d-arrow-right"
                  @click.native.prevent="selectRow(scope.$index, searchItems)"
                />
                <i v-else class="el-icon-lock" />
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="width: 49%;">
          <div>
            <div style="float: left;color:#409EFF">
              {{ $t('CargoMsg.Cargo_MyQueryCriteria') }}【{{
                multipleSelection.length
              }}{{ $t('CargoMsg.Cargo_Pcs') }}】
            </div>
            <!--<div style="float: right">
              <el-button type="primary" size="mini" @click="saveDefault">设置为默认</el-button>
              <el-button type="warning" size="mini" @click="resetGlobalDefaultScheme">重置至系统默认</el-button>
            </div>-->
          </div>
          <el-table
            v-if="isShowAbc"
            ref="multipleTable"
            no="multipleTable2"
            :data="multipleSelection"
            class="choose-item-table"
            :row-key="row => row.itemName + row.fieldType"
            size="mini"
            height="400"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column
              prop="itemLabel"
              :label="$t('CargoMsg.Cargo_DisplayName')"
              width="150"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ i18nAdvSearch(scope.row.itemLabel) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="itemCondition"
              :label="
                showCondition ? $t('CargoMsg.Cargo_ConditionalExpression') : ''
              "
              width="155"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-select
                  v-if="
                    scope.row.itemCondition &&
                      scope.row.itemCondition.length > 0 &&
                      showCondition
                  "
                  v-model="scope.row.defaultConditionVal"
                  :no="scope.row.itemLabel+'condition'"
                  style="width: 80px"
                  size="mini"
                  :placeholder="$t('CargoMsg.Cargo_PleaseSelect')"
                >
                  <el-option
                    v-for="(item, index) in scope.row.itemCondition || []"
                    :key="item.code+'-'+ index"
                    :label="
                      i18nAdvSearch('advanceSearchForm.' + item.englishName)
                    "
                    :value="item.code"
                  />
                </el-select>
                <div v-else style="width: 80px;display: inline-block" />
              </template>
            </el-table-column>
            <!--<el-table-column-->
            <!--prop="itemName"-->
            <!--label="代码"-->
            <!--width="95"-->
            <!--show-overflow-tooltip-->
            <!--/>-->
            <!--<el-table-column-->
            <!--label="类型"-->
            <!--width="85"-->
            <!--show-overflow-tooltip-->
            <!--&gt;-->
            <!--<template slot-scope="scope">{{ scope.row.itemType }}</template>-->
            <!--</el-table-column>-->
            <el-table-column :label="$t('CargoMsg.Cargo_Operation')" width="95">
              <template slot-scope="scope">
                <!--<el-button-->
                <!--type="text"-->
                <!--size="small"-->
                <!--icon="el-icon-upload2"-->
                <!--@click.native.prevent="moveUp(scope.$index, multipleSelection)"/>-->
                <!--<el-button-->
                <!--type="text"-->
                <!--size="small"-->
                <!--icon="el-icon-download"-->
                <!--@click.native.prevent="moveDown(scope.$index, multipleSelection)"/>-->
                <el-button
                  v-if="!scope.row.lock && !scope.row.fix"
                  :no="scope.row.itemLabel+'operation'"
                  type="text"
                  size="small"
                  icon="el-icon-close"
                  @click.native.prevent="
                    deleteSearchItem(scope.$index, multipleSelection)
                  "
                />
                <i v-else class="el-icon-lock" />
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
    <!--状态追踪-->
    <el-dialog
      v-el-drag-dialog
      no="sopStateTrack"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      custom-class="sop-state-track"
      :visible.sync="sopStateTrack.isShow"
      :title="$t(sopStateTrack.currentItem.itemLabel)"
      width="1000px"
      :append-to-body="appendToBody"
      @close="toCancelEditSopStateTrack"
    >
      <div>
        <el-radio-group v-show="sourcePage=== 'sales' || sourcePage === 'finance'" :value="sopStateLob" no="sales" style="width: 100%;" @input="onLobInput">
          <el-radio no="SE" label="SE">{{ $t('CargoMsg.Cargo_OceanExport') }}</el-radio>
          <el-radio no="SI" label="SI">{{ $t('CargoMsg.Cargo_OceanImport') }}</el-radio>
          <el-radio no="AE" label="AE">{{ $t('CargoMsg.Cargo_AirExport') }}</el-radio>
          <el-radio no="AI" label="AI">{{ $t('CargoMsg.Cargo_AirImport') }}</el-radio>
          <el-radio no="RE" label="RE">{{ $t('CargoMsg.Cargo_RailwayBusiness') }}</el-radio>
          <el-radio no="IE" label="IE">{{ $t('CargoMsg.Cargo_IntegratedJob') }}</el-radio>
        </el-radio-group>
        <el-radio-group v-model="sopStateTrack.dialog.operator" no="operator" style="margin-top: 10px;">
          <el-radio no="and" label="and">{{ $t('advanceSearchForm.fitAll') }}</el-radio>
          <el-radio no="or" label="or">{{ $t('advanceSearchForm.fitAny') }}</el-radio>
        </el-radio-group>
      </div>
      <div
        style="overflow-y: auto;overflow-x: hidden;height: 400px;padding-right: 5px;margin-top: 10px;"
      >
        <el-form label-width="150px" :inline="true" label-position="left">
          <el-form-item
            v-for="(track, index) in sopStateTrack.dialog.data"
            :key="`${track.code}-${index}`"
            :label="isZh ? track.codeCname : track.codeEname"
            style="width: 48%;"
          >
            <div style="display: flex;justify-content: space-between">
              <div style="width: 50px;">{{ $t('advanceSearchForm.In') }}</div>
              <el-select
                :ref="`track${index}`"
                v-model="sopStateTrack.dialog.currentValue[track.code]"
                class="multi-select"
                multiple
                :placeholder="$t('common.pleaseChoose')"
                @change="() => convertSelectedToText(`track${index}`)"
              >
                <el-option
                  v-for="(td,index) in track.trackingDetail"
                  :key="`${td.code}-${index}`"
                  :label="td.codeCname"
                  :value="td.code"
                />
              </el-select>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button no="confirm" type="primary" @click="toConfirmEditSopStateTrack">{{
          $t('common.confirm')
        }}</el-button>
        <el-button no="reset" type="danger" @click="toResetSopStateTrack">{{
          $t('common.reset')
        }}</el-button>
        <el-button no="cancel" @click="toCancelEditSopStateTrack">{{
          $t('common.cancel')
        }}</el-button>
      </span>
    </el-dialog>
    <!--文本域但框-->
    <el-dialog
      v-el-drag-dialog
      no="EditTextArea"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :visible.sync="isShowEditTextArea"
      :title="currentInputItem.itemLabel"
      width="500px"
      :append-to-body="appendToBody"
    >
      <el-form
        label-width="190px"
        label-position="top"
        style="margin-top:-30px;"
      >
        <div style="color:#409EFF">{{ $t('CargoMsg.Cargo_MultipleWorkNoEnter') }}</div>
        <el-form-item label="">
          <el-input
            v-model="dialogTextAreaValue"
            size="mini"
            type="textarea"
            rows="6"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          no="Confirm"
          type="primary"
          size="mini"
          @click="toConfirmEditTextArea"
        >{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button
          no="Cancel"
          type="primary"
          size="mini"
          @click="toCancelEditTextArea"
        >{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 保存修改弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="saveModifiedDialog.visible"
      :title="$t('Message.SaveScheme')"
      :width="$selectByLang('250px', '250px', '250px', '400px', '400px', '400px')"
      :close-on-click-modal="false"
      class="save-modified-dialog"
      append-to-body
    >
      <el-form>
        <el-form-item label-width="0">
          <el-checkbox v-model="saveModifiedDialog.isSaveColumnState">{{ $t('Message.SaveColumnSettingsSameTime') }}</el-checkbox>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button type="primary" @click="doSaveModified">{{ $t('common.btn.ok') }}</el-button>
        <el-button @click="saveModifiedDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 另存为方案弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="saveSchemeDialog.visible"
      :title="$t('CargoMsg.Cargo_NewQueryScheme')"
      width="400px"
      :close-on-click-modal="false"
      class="save-scheme-dialog"
      append-to-body
    >
      <el-form label-width="100px" label-position="left">
        <el-form-item :label="$t('CargoMsg.Cargo_SchemeName')" />
        <el-form-item label-width="0">
          <el-input v-model="saveSchemeDialog.name" />
        </el-form-item>
        <el-form-item label-width="0">
          <el-checkbox v-model="saveSchemeDialog.isSaveColumnState">{{ $t('Message.SaveColumnSettingsSameTime') }}</el-checkbox>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button type="primary" @click="doSaveScheme">{{ $t('common.btn.ok') }}</el-button>
        <el-button @click="saveSchemeDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- EDI状态查询弹窗 -->
    <edi-state-query-dialog
      v-if="ediStateQueryDialog.isCreate"
      :visible.sync="ediStateQueryDialog.visible"
      :title="ediStateQueryDialog.title"
      :value="ediStateQueryDialog.value"
      @callback="ediStateQueryDialog.callback"
    />

    <!-- 操作要求弹窗 -->
    <select-operation-req-dialog
      v-if="selectOperationReqDialog.visible"
      :visible.sync="selectOperationReqDialog.visible"
      lob="AE"
      :value="selectOperationReqDialog.value"
      @callback="updateOperationItemValue"
    />

    <!-- 特殊操作代码弹窗 -->
    <select-special-operation-code-dialog
      v-if="selectSpecialOperationCodeDialog.visible"
      :visible.sync="selectSpecialOperationCodeDialog.visible"
      lob="AE"
      :value="selectSpecialOperationCodeDialog.value"
      @callback="updateSpecialOperationCodeItemValue"
    />
  </div>
</template>
<script>
import cargoPostCodeSelect from '@/components/Cargo/Common/cargoPostCodeSelect'
import cargoLimitedSelect from '@/components/Cargo/Common/cargoLimitedSelect'
import CargoDateTimePicker from '@/components/Cargo/Common/CargoDateTimePicker'
import lodash from 'lodash'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoCascader from '@/components/Cargo/Common/cargoCascader'
import cargoCascaderMulti from '@/components/Cargo/Common/cargoCascaderMulti'
import cargoMultiLineTextPopover from '@/components/Cargo/Common/cargoMultiLineTextPopover'
import URL from '@/api/urlTranslator'
import {
  getPersonQueryConfig,
  getGlobalQueryConfig,
  savePersonQueryConfig,
  setDefault,
  delPersonQueryConfig,
  delPerConfigByIdOrConfigName,
  getAdvQueryResult,
  getSimQueryResult
} from '@/api/commonComponent'
import Sortable from 'sortablejs'
import { getLoading } from '@/utils/utilBaseElement'
import { deepClone, getLength } from '@/utils'
import { isArray, isNumber, isNumber2 } from '@/utils/validate'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import { getTrackingInfoByLob } from '@/api/seaExport/seaExportJob'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { ensureExecuteSuccess } from '@/utils/commonUtil'
import { getUserInfo } from '@/utils/auth'
import * as AdvancedSearchConsts from '@/class/cargo/model/utils/AdvancedSearchConsts'
import { ACTIONS as searchItemActions } from '@/class/cargo/model/parameters/AdvancedSearchField'
import * as TrackingConstants from '../../../class/cargo/model/parameters/TrackingConstants'
import moment from 'moment'
import { mapGetters } from 'vuex'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import cargoProjectNameSelect from '@/components/Cargo/Common/cargoProjectNameSelect'
import CargoHqCompanySelect from '@/components/Cargo/Common/cargoHqCompanySelect'
import CargoSalesCompanySelect from '@/components/Cargo/Common/cargoSalesCompanySelect'
import ContainerLoadTypeCascader from '@/components/Cargo/Job/containerLoadTypeCascader'
import CountryAreaCascader from '@/components/Cargo/Common/countryAreaCascader'
import EdiStateQueryDialog from '@/components/Cargo/Job/EdiStateQueryDialog'
import CargoOwnedBranchSelect from '@/components/Cargo/Common/CargoOwnedBranchSelect'
// import { ALL_USER_2, FIELD_INCOTERM } from '@/class/cargo/model/utils/AdvancedSearchConsts'
import { JOB_STATES } from '@/utils/cacheConfig'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import ColumnUtils from '@/utils/ColumnUtils'
import OfficeWithChildSelect from '@/components/Cargo/Common/OfficeWithChildSelect'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import SelectOperationReqDialog from '@/components/Cargo/Job/selectOperationReqDialog.vue'
import SelectSpecialOperationCodeDialog from '@/components/Cargo/Job/selectSpecialOperationCodeDialog.vue'
import { cache, cacheName } from '@/utils/cacheManager'

export default {
  name: 'CargoCombinationSearch',
  components: {
    cargoPostCodeSelect,
    SelectSpecialOperationCodeDialog,
    SelectOperationReqDialog,
    CargoButtonGroupSlider,
    cargoLimitedSelect,
    cargoAdvanceSelect,
    cargoCascader,
    cargoMultiLineTextPopover,
    CargoDateTimePicker,
    cargoProjectNameSelect,
    CargoHqCompanySelect,
    CargoSalesCompanySelect,
    ContainerLoadTypeCascader,
    CountryAreaCascader,
    cargoCascaderMulti,
    EdiStateQueryDialog,
    CargoOwnedBranchSelect,
    OfficeWithChildSelect
  },
  directives: {
    // 注册一个局部的自定义指令 v-focus
    focus: {
      // 指令的定义
      inserted: function(el) {
        // 聚焦元素
        el.querySelector('input').focus()
      }
    }
  },
  props: {
    retainDefaultValue: { type: Boolean, default: false }, // 是否开启保留当前选择的配置的已选值
    isAppendQuery: { type: Boolean, default: false }, // 追加查询，默认不显示
    isCollapseList: { type: Boolean, default: false }, // 收起列表，默认不显示
    gridOptions: { type: Object, default: null }, // 收起列表，默认展开
    autoInit: { type: Boolean, default: true }, // 是否自动初始化，因为有时需要合并外部SearchItems
    isSimpleQuery: { type: Boolean, default: false }, // 当前查询模式标识
    showCondition: { type: Boolean, default: true }, // 显示条件表达式
    appendToBody: { type: Boolean, default: false }, // 将内层 Dialog 的该属性设置为 true，它就会插入至 body 元素上，从而保证内外层 Dialog 和遮罩层级关系的正确。
    sourcePage: { type: String, default: '' }, // 来源页面
    customSimQueryPlaceholder: { type: String, default: null }, // 快捷检索占位文字
    isSeaExportJobList: { type: Boolean, default: false }, // 是否在海出列表页上
    isFinancialOverview: { type: Boolean, default: false }, // 是否在业务总览页面上
    marginR: { type: [String, Number], default: '10' },
    showSimple: { type: Boolean, default: true }, // 显示简单UI查询
    showAdv: { type: Boolean, default: true }, // 显示高级查询
    expandAdv: { type: Boolean, default: false }, // 是否初始展开高级查询
    showMoreScheme: { type: Boolean, default: true }, // 是否显示更多方案
    reset: { type: Boolean, default: false }, // 是否可以重置查询
    searchItemCode: { type: String, default: '' },
    searchItemMode: { type: String, default: '' }, // 如果为 querydata 则该组件会根据url自动发起请求进行查询
    simUrl: { type: String, default: '' }, // 简单查询url
    advUrl: { type: String, default: '' }, // 高级查询url
    configModule: { type: String, default: '' }, // 高级查询业务module值
    gridConfigModule: { type: String, default: '' }, // 关联的表格module值
    customSearchItems: { type: Array, default: () => [] }, // 外部自定义（新增、移除、修改）的查询项,在保存个人方案时，本数组中的相关项(*标记新增的*)会被过滤剔除
    hiddenSearchItemFilter: { type: Function, default: null }, // 外部过滤函数：返回 true 的方案下发查询项会被剔除，用于页面级隐藏某些查询条件字段
    disabled: { type: Boolean, default: () => false }, // 禁用
    searchDisabled: { type: Boolean, default: () => false }, // 禁用
    lob: { type: String, default: () => 'SE' }, // 业务类型
    colSettings: {
      type: Object,
      default: () => ({
        xs: 12,
        sm: 12,
        md: 12,
        lg: 8,
        xl: 6
      })
    },
    isBranchCooperate: { type: Boolean, default: false }, // 本公司协助业务，默认不显示
    recordExpandStatus: { type: Boolean, default: false }, // 是否记录展开状态
    inputEnterQuery: { type: Boolean, default: false } // 文本框回车触发查询
  },
  data() {
    const str = '快捷检索:业务编号/提单号/关单号'
    let simQueryPlaceholder = str
    if (!this.customSimQueryPlaceholder) {
      switch (
        this.sourcePage // 根据不同的来源，个性化显示占位符
      ) {
        case 'partner': // 客商
          simQueryPlaceholder = '快捷检索:助记码/简称/中英名'
          break
        case 'invoice': // 发票列表
          simQueryPlaceholder += '/发票号'
          break
        case 'overView': // 业务台账
          simQueryPlaceholder += ''
          break
        case 'seGrid': // 海出列表
          simQueryPlaceholder = '/业务编号'
          break
        case 'bill': // 账单列表
          simQueryPlaceholder += '/账单号'
          break
        case 'applyPayment': // 付款申请
          simQueryPlaceholder += '/付款申请号'
          break
        case 'chargeDetail': // 财务-费用明细
          simQueryPlaceholder += ''
          break
        case 'clear': // 财务-核销
          simQueryPlaceholder += '/核销编号'
          break
        case 'check': // 财务-对账单
          simQueryPlaceholder += '/对账单号'
          break
        case 'realCash': // 财务-实收付管理
          simQueryPlaceholder += '/实收付编号'
          break
        case 'finReleaseBill': // 财务-放单管理
          simQueryPlaceholder += '/放单号'
          break
        case 'seReleaseBill': // 海出-放单管理
          simQueryPlaceholder += '/放单号'
          break
        case 'chargeScheme': // 计费方案
          simQueryPlaceholder += '/方案编号'
          break
        default:
          simQueryPlaceholder = this.i18nAdvSearch('advanceSearchForm.quickSearch')
          break
      }
      if (this.configModule === '507') {
        // 选择费用
        simQueryPlaceholder = str
      }
    } else {
      simQueryPlaceholder = this.customSimQueryPlaceholder
    }
    let isShowingMoreSearchCondition = this.expandAdv
    if (this.recordExpandStatus) {
      const expandStatus = LocalStorageUtilsNew.getConfiguration('expandStatus-' + this.configModule)
      if (typeof expandStatus === 'boolean') {
        isShowingMoreSearchCondition = expandStatus
      }
    }
    return {
      JOB_STATES,
      accountObjectControlMode: 0,
      visible: this.autoInit,
      selectTypeNames: TYPE_NAMES,
      stateTypes: [...SeaExportConstants.STATE_TYPES],
      preQueryMode: 'adv', // 上次查询方式（adv-高级，simple简单）
      simQueryPlaceholder: simQueryPlaceholder, // 快捷检索 占位符
      testItemValue: '',
      multiLineTextVisible: false, // 多行文本是否可见
      sopStateTrack: {
        dialog: {
          operator: 'and', // 1 包含全部【and】,2任意[or]
          data: [],
          initCurrentValue: {},
          currentValue: {}
        },
        isShow: false,
        currentItem: {
          richItemValue: [],
          itemValue: {},
          txtContent: ''
        },
        cache: new Map()
      },
      isShowEditTextArea: false,
      dialogTextAreaValue: '',
      currentInputItem: {},
      AdvancedSearchConsts,
      isShowingSimSearchCondition: false,
      isShowingMoreSearchCondition,
      isShowingSummary: true,
      isShowAbc: false, // 方案配置
      isShowSaveAs: false,
      keyWords: null,
      canOptMoreBtn: false,
      loading: false,
      searchTemplate: {
        value: '',
        label: '',
        default: true
      },
      selectedConfigValue: '', // 选择的方案id
      configQuickBtnCount: 5,
      perConfigs: [], // 个人配置全量(包含默认的)
      perConfig: {
        bDefault: false,
        configContent: '',
        configModule: this.configModule,
        configName: '',
        configType: 1
      },
      isShowSearchItem: true,
      appendQuery: false, // 追加查询
      collapseList: false, // 收起列表，默认展开
      multipleSelection: [], // 当前选择的配置的 相关项
      defaultSearchItems: [],
      searchItems: [],
      shortcutDatesExtend: [
        { label: 'FinanceManage.today', value: -1 }
      ],
      shortcutDates: [
        { label: 'advanceSearchForm.nowWeek', value: 0 },
        { label: 'advanceSearchForm.preWeek', value: 1 },
        { label: 'advanceSearchForm.nextWeek', value: 2 },
        { label: 'advanceSearchForm.nowMonth', value: 3 },
        { label: 'advanceSearchForm.preMonth', value: 4 },
        { label: 'advanceSearchForm.nextMonth', value: 5 }
      ],
      queryFilter: '',
      getLength,
      sopStateLob: 'SE', // 状态追踪业务类型,默认海出
      originalTruckingData: { // 点击确定时赋值，然后如果客户点击了取消按钮，则要把该数据赋值到弹窗中。
        rowData: [],
        lob: 'SE'
      },
      emptyPlaceholder: ' ', // 空白占位符（传空字符的话，不会生效，依然会使用组件本身的占位符）
      saveModifiedDialog: {
        visible: false,
        isSaveColumnState: false
      },
      saveSchemeDialog: {
        visible: false,
        name: '',
        isSaveColumnState: false
      },
      branchCooperate: false, // 本公司协助业务
      ediStateQueryDialog: { // EDI状态查询弹窗
        isCreate: false,
        visible: false,
        title: '',
        value: {},
        callback: null
      },
      // 操作要求
      selectOperationReqDialog: {
        visible: false,
        currentItem: null,
        value: ''
      },
      // 特殊操作码
      selectSpecialOperationCodeDialog: {
        visible: false,
        currentItem: null,
        value: ''
      }
    }
  },
  computed: {
    ...mapGetters(['language']),
    isZh() {
      return this.language === 'zh'
    },
    url() {
      return URL
    },
    quickBtnConfigs() {
      return this.perConfigs.slice(0, this.configQuickBtnCount)
    },
    commandConfigs() {
      return this.perConfigs.slice(this.configQuickBtnCount)
    },
    commandConfig() {
      // 当前配置是否属于 command
      return this.commandConfigs.find(
        item => item.id === this.selectedConfigValue
      )
    },
    perConfigName() {
      if (this.perConfig && this.perConfig.configName) {
        return this.perConfig.configName
      }
      return ''
    },
    defConfig() {
      return this.perConfigs.find(item => item.bDefault) || {
        bDefault: false,
        configContent: '',
        configModule: this.configModule,
        configName: 'default',
        configType: 1
      }
    },
    filteredSearchItems() {
      if (this.queryFilter) {
        return this.searchItems.filter(item => {
          console.log(
            this.i18nAdvSearch(item.itemLabel).search(this.queryFilter)
          )
          return (
            this.i18nAdvSearch(item.itemLabel).search(this.queryFilter) !== -1
          )
        })
      }
      return this.searchItems
    },
    simQueryPlaceholderValue() {
      if (this.customSimQueryPlaceholder) {
        return this.customSimQueryPlaceholder
      } else {
        return this.simQueryPlaceholder
      }
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      immediate: true,
      async handler() {
        await cache.load(cacheName.CONFIG)
        this.accountObjectControlMode = Number(cache.config.get('AccountObjectControlMode'))
      }
    },
    customSearchItems: {
      handler: function(newVal, oldVal) {
        if (!this.visible && newVal && newVal.length > 0) {
          console.log('customSearchChange')
          this.visible = true
          this.fetchInitData()
        } else {
          this.fillPerConfig(this.perConfig.configName, true)
        }
      }
    },
    multipleSelection(newVal, oldVal) {
      this.fillSearchItems()
      // CARGO-20437件毛体为空时，会悬浮显示“undefined”
      newVal.forEach(eve => {
        if (eve.subType === 'bigdecimalrange' || eve.subType === 'bigdecimalForPositive' || eve.subType === 'bigdecimalrangeForPositive' || eve.subType === 'bigdecimalrangeWithPrecision') {
          this.$nextTick(() => {
            const numInputRef = this.$refs[`${eve.itemName}${eve.itemType}${this.selectedConfigValue}`]
            const numInputs = Array.isArray(numInputRef) ? numInputRef : numInputRef ? [numInputRef] : []
            console.log(numInputRef)
            numInputs.forEach(e => {
              e.$children[0].$el.children[0].title = ''
            })
          })
        }
      })
    },
    configModule(newVal, oldVal) {
      this.perConfig = {
        bDefault: false,
        configContent: '',
        configModule: this.configModule,
        configName: '',
        configType: 1
      }
      if (newVal !== oldVal && this.visible) {
        this.fetchInitData()
        this.keyWords = null
        this.$emit('update:isSimpleQuery', !this.isShowingMoreSearchCondition)
      }
    },
    perConfigName: {
      immediate: true,
      handler(newVal) {
        this.$emit('perConfigChange', newVal)
      }
    },
    isShowingMoreSearchCondition(newVal) {
      this.$emit('advToggle', newVal)
    },
    lob(newVal) {
      this.sopStateLob = newVal
      if (!this.sopStateLob) {
        this.sopStateLob = 'SE'
      }
    }
  },
  mounted() {
    if (this.isCollapseList) {
      this.collapseList = LocalStorageUtilsNew.getConfiguration('CollapseList-' + this.configModule)
    }
    if (this.visible) {
      this.fetchInitData()
      this.$emit('update:isSimpleQuery', !this.isShowingMoreSearchCondition)
    }
    this.$emit('click-more', this.isShowingMoreSearchCondition)
    // this.rowDrop()
  },
  methods: {
    // 获取 3 个月前的日期
    getThreeMonthsAgo(date) {
      const result = new Date(date)
      result.setDate(result.getDate() - 90)
      return result
    },
    // 获取 3 个月后的日期
    getThreeMonthsLater(date) {
      const result = new Date(date)
      result.setDate(result.getDate() + 90)
      return result
    },

    /**
     * 打开操作要求弹窗
     * @param item
     */
    openSelectOperationDialog(item) {
      this.selectOperationReqDialog.currentItem = item
      this.selectOperationReqDialog.visible = true
      this.selectOperationReqDialog.value = item.itemValue
    },
    /**
     * 更新操作要求
     * @param newValue
     */
    updateOperationItemValue(newValue) {
      if (this.selectOperationReqDialog.currentItem) {
        this.selectOperationReqDialog.currentItem.itemValue = newValue
      }
    },
    /**
     * 打开特殊操作码弹窗
     * @param item
     */
    openSelectSpecialOperationCodeDialog(item) {
      this.selectSpecialOperationCodeDialog.currentItem = item
      this.selectSpecialOperationCodeDialog.visible = true
      this.selectSpecialOperationCodeDialog.value = item.itemValue
    },
    /**
     * 更新操作要求
     * @param newValue
     */
    updateSpecialOperationCodeItemValue(newValue) {
      if (this.selectSpecialOperationCodeDialog.currentItem) {
        this.selectSpecialOperationCodeDialog.currentItem.itemValue = newValue
      }
    },
    i18nAdvSearch(key) {
      const name = `${key}`
      const value = this.$t(`${key}`)
      if (value === name) {
        return key
      }
      return value
    },
    onCondChange(val, item) {
      // todo 因后续以扩展其他功能，需要重测
      item.defaultConditionVal = val
      // 如果条件值为 IS NULL,则清空文本框的值
      if (item.defaultConditionVal === 'IS NULL') {
        item.itemValue = ''
      }
      if (item.itemType === 'date') {
        // 日期类型 因需要切换值控件，需要特殊处理
        if (val === 'DATE ITEM') {
          // 快捷选项
          if (item.dateItemExtend === 1) {
            item.itemValue = -1 // 默认当天
          } else {
            item.itemValue = 0 // 默认本周
          }
        } else {
          item.itemValue = []
        }
      }
      // CARGO-29765 先选择等于选一个用户然后选择包含，不填值，查询报错
      if ((item.itemType === AdvancedSearchConsts.FIELD_USER_SEA || item.itemType === AdvancedSearchConsts.FIELD_USER) &&
          (item.defaultConditionVal === AdvancedSearchConsts.OPERATOR_IN.code || item.defaultConditionVal === AdvancedSearchConsts.OPERATOR_NOT_IN.code)) {
        item.itemValue = []
      }

      if ((item.itemType === AdvancedSearchConsts.FIELD_INCOTERM) &&
        (item.defaultConditionVal === AdvancedSearchConsts.OPERATOR_IN.code || item.defaultConditionVal === AdvancedSearchConsts.OPERATOR_NOT_IN.code)) {
        item.itemValue = []
      }

      if (item.itemType === 'cutomJobType' || item.itemType === AdvancedSearchConsts.FIELD_COMPANY || item.itemType === AdvancedSearchConsts.FIELD_HQ_COMPANY || item.itemType === 'chargeItem' || (item.itemType === 'currency' && item.multiple !== 1) || item.itemType === 'seaport' ||
        item.itemType === AdvancedSearchConsts.ALL_USER_2 || item.itemType === 'region' || item.itemType === 'railwayLine2' || item.itemType === AdvancedSearchConsts.FIELD_REGION_MUTI) {
        switch (item.defaultConditionVal) {
          case AdvancedSearchConsts.OPERATOR_EQUAL.code:
          case AdvancedSearchConsts.OPERATOR_UNEQUAL.code:
            if (item.itemValue instanceof Array) {
              item.itemValue = item.itemValue.length ? item.itemValue[0] : ''
            }
            break
          case AdvancedSearchConsts.OPERATOR_IN.code:
          case AdvancedSearchConsts.OPERATOR_NOT_IN.code:
            if (!(item.itemValue instanceof Array)) {
              item.itemValue = item.itemValue === '' || item.itemValue === undefined || item.itemValue === null
                ? []
                : [item.itemValue]
            }
            break
        }
      }

      this.$emit('itemConditionChange', item)
    },
    /**
     * 添加element表格行拖拽支持
     * @param tableClass 表格class
     * @param tableDataRef  表格数据引用
     */
    rowDrop(tableClass, tableDataRef) {
      // 拖拽
      this.$nextTick(() => {
        const tbody = document.querySelector(
          `.${tableClass} .el-table__body-wrapper tbody`
        )
        Sortable.create(tbody, {
          onEnd({ newIndex, oldIndex }) {
            const currRow = tableDataRef.splice(oldIndex, 1)[0]
            tableDataRef.splice(newIndex, 0, currRow)
          }
        })
      })
    },
    // todo 有的是自定义配置
    coverSearchItems() {},
    preProcessSearchItem(originSearchItems, isGlobal = false) {
      // 页面级隐藏：先按外部过滤函数剔除方案下发的查询项（覆盖全量字段目录与个人方案已选条件）
      if (typeof this.hiddenSearchItemFilter === 'function' && Array.isArray(originSearchItems)) {
        for (let i = originSearchItems.length - 1; i >= 0; i--) {
          if (this.hiddenSearchItemFilter(originSearchItems[i])) {
            originSearchItems.splice(i, 1)
          }
        }
      }
      // console.log('customSearchItems', this.customSearchItems, [...this.customSearchItems])
      console.log('this.customSearchItems:', this.customSearchItems)
      if (!this.customSearchItems || !Array.isArray(this.customSearchItems)) {
        this.$emit('preProcessSearchItem', originSearchItems)
        return
      }
      for (const item of lodash.cloneDeep(this.customSearchItems)) {
        const index = originSearchItems.findIndex(
          e => e.itemName === item.itemName && e.fieldType === item.fieldType
        )
        switch (item.action) {
          case searchItemActions.REMOVE_ACTION:
            if (index > -1) {
              originSearchItems.splice(index, 1)
            } else {
              console.warn('未找到需要剔除的searchItem:', item)
            }
            break
          case searchItemActions.UPDATE_ACTION:
            if (index > -1) {
              if (!item.defaultConditionVal) {
                item.defaultConditionVal =
                  originSearchItems[index].defaultConditionVal
              }
              if (
                (!item.defaultValue &&
                  typeof item.defaultValue !== 'boolean' &&
                  item.defaultValue !== 0 &&
                  item.defaultValue !== undefined) ||
                (Array.isArray(item.defaultValue) && !item.defaultValue.length)
              ) {
                item.defaultValue = originSearchItems[index].defaultValue
              }
              if (item.itemCondition.length === 0) {
                item.itemCondition = originSearchItems[index].itemCondition
              }
              if (originSearchItems[index].selected) {
                item.selected = 1
              }
              if (
                item.itemType === 'select' &&
                item.valueExpression &&
                item.valueExpression.valueType === 'static'
              ) {
                const staticValue = item.valueExpression.valueContent.map(
                  value => value.code
                )
                if (Array.isArray(item.defaultValue)) {
                  item.defaultValue = item.defaultValue.filter(value =>
                    staticValue.includes(value)
                  )
                } else {
                  item.defaultValue = staticValue.includes(item.defaultValue)
                    ? item.defaultValue
                    : null
                }
                console.log('itemValue', item.defaultValue)
              }
              originSearchItems.splice(index, 1, { ...item })
            } else {
              originSearchItems.push({ ...item })
            }
            if (item.itemType === 'roleType') {
              console.log('item:', item)
            }
            break
          default:
            if (isGlobal || item.lock) {
              // isGlobal=false非全局的查询条件，需要根据lock区别对待
              if (index < 0) {
                originSearchItems.push({ ...item })
              } else {
                Object.keys(item).map(key => {
                  originSearchItems[index][key] = item[key]
                })
              }
            }
        }
      }
      // originSearchItems.push(...[...this.customSearchItems])
      this.$emit('preProcessSearchItem', originSearchItems)
    },
    supplementSearchItems(originSearchItems, isGlobal = false) {
      originSearchItems.forEach(item => {
        // 下面这行注释了，之前加的目的是为了初始化显示默认值的(和@小祥确认了) - 先还原了
        item.itemValue = item.defaultValue
        if (Object.prototype.hasOwnProperty.call(item, 'fieldType')) {
          const fieldType = item.fieldType
          const operationType = item.operationType || AdvancedSearchConsts[fieldType]

          const operationArr = AdvancedSearchConsts.FIELD_OPERATOR_MAP[
            operationType
          ] || [AdvancedSearchConsts.OPERATOR_EQUAL] // 默认等于
          // 海运/空运「航线」(regionMuti)：用 FIELD_OPERATOR_MAP 覆盖方案里的 itemCondition，保证能出「不等于」。
          // transportLine / transportLine2 不覆盖，沿用方案 itemCondition（避免铁路「铁路航线」等标题/条件被刷成通用航线）。
          const useOperatorMapOverConfig =
            operationType === AdvancedSearchConsts.FIELD_REGION_MUTI
          // 增补下拉条件
          // item.itemCondition = []
          // item.defaultConditionVal = ''
          if (operationArr && operationArr.length) {
            if (
              item.itemCondition &&
              item.itemCondition.length > 0 &&
              !useOperatorMapOverConfig
            ) {
              console.warn(
                'itemCondition in the configuration file first used' +
                  ' at config-moudle=' +
                  this.configModule
              )
              item.defaultConditionVal = item.defaultConditionVal
                ? item.defaultConditionVal
                : item.itemCondition[0].code
            } else {
              item.itemCondition = operationArr
              item.defaultConditionVal = item.defaultConditionVal
                ? item.defaultConditionVal
                : operationArr[0].code
            }
          } else {
            console.error(
              'not found operationArr of ' +
                fieldType +
                ' at config-moudle=' +
                this.configModule
            )
          }
        }
        if (
          item.selected &&
            (item.itemType === 'stateTypes' || item.itemType === 'select') &&
            (!item.itemValue || item.itemValue.length === 0)
        ) {
          this.$nextTick(() => {
            this.manualCleanSelect(item)
          })
        }
        if (
          item.selected &&
            (item.itemType === 'stateTypes' || item.itemType === 'select') &&
            item.itemValue &&
            item.itemValue.length > 0
        ) {
          this.$nextTick(() => {
            this.convertSelectedToText(
              `${item.itemName}${item.itemType}${this.selectedConfigValue}`
            )
          })
        }
      })
      if (isGlobal) {
        return originSearchItems
      }
      return originSearchItems.filter(item => item.selected)
    },
    resetGlobalDefaultScheme() {
      this.multipleSelection = this.searchItems.filter(item => {
        return item.defaultSelected === 1
      })
      this.selectedConfigValue = ''
      // this.multipleSelection = []
    },
    assembleGlobalDefaultScheme() {
      this.resetGlobalDefaultScheme()
      this.toInitSopStateTrackSearchItem()
      // this.fillSearchItems()
    },
    mergePerConfigIntoSearchItems(config) {
      config.forEach(item => {
        const index = this.searchItems.findIndex(
          sc =>
            sc.itemName === item.itemName &&
            sc.fieldType === item.fieldType &&
            sc.itemType === item.itemType
        )
        if (index > -1) {
          const searchItem = this.searchItems[index]
          this.searchItems[index] = { ...searchItem, ...item }
        } else {
          this.searchItems.push({ ...item })
        }
      })
    },
    mergePerConfigWithSearchItems(config) {
      return config.map(item => {
        const searchItem = this.searchItems.find(
          sc =>
            sc.itemName === item.itemName &&
            sc.fieldType === item.fieldType &&
            sc.itemType === item.itemType
        )
        if (searchItem) {
          return { ...searchItem, ...item }
        } else {
          return item
        }
      })
    },
    fillSearchItems() {
      for (let i = 0; i < this.searchItems.length; i++) {
        this.searchItems[i].selected = 0 // 方案配置中 是否选中的标识
        for (let j = 0; j < this.multipleSelection.length; j++) {
          if (
            this.multipleSelection[j].itemName ===
              this.searchItems[i].itemName &&
            this.multipleSelection[j].itemType ===
              this.searchItems[i].itemType &&
            this.multipleSelection[j].fieldType ===
              this.searchItems[i].fieldType
          ) {
            this.searchItems[i].selected = 1
          }
        }
      }
    },
    toShowConfigSearchItem() {
      this.isShowAbc = true
      this.rowDrop('choose-item-table', this.multipleSelection)
    },
    showSaveAsDialog() {
      // 方案配置、方案另存为
      this.isShowSaveAs = true
      this.searchTemplate.label = ''
      // this.rowDrop('maintain-item-table', this.perConfigs)
    },
    async fetchSopStateTrackData() {
      if (
        this.sopStateTrack.dialog.data &&
        this.sopStateTrack.dialog.data.length
      ) {
        // 已经加载过了
        return
      }
      await getTrackingInfoByLob(this.lob).then(res => {
        const values = {}
        let trackings = []
        if (this.lob === 'SE' || this.lob === 'AE' || this.lob === 'AI' || this.lob === 'RE' || this.lob === 'IE') {
          trackings = res.data
        } else if (this.lob === 'SI') {
          for (const tracking of res.data) {
            if (tracking.nodeType === TrackingConstants.NOTE_TYPE_E.code) {
              continue
            }
            if (
              tracking.nodeType === TrackingConstants.NOTE_TYPE_SUPPLEMENT.code
            ) {
              continue
            }
            trackings.push(tracking)
          }
        }

        trackings.forEach(item => {
          // 初始化 结构
          values[item.code] = []
        })
        this.sopStateTrack.dialog.initCurrentValue = deepClone(values)
        this.sopStateTrack.dialog.data = trackings
      })
    },
    async fetchInitData() {
      this.canOptMoreBtn = false
      try {
        const result = await Promise.all([
          getGlobalQueryConfig(1, this.configModule),
          getPersonQueryConfig({
            configType: 1,
            configModule: this.configModule
          })
        ])
        this.defaultSearchItems = JSON.parse(result[0].data.configContent)
        this.$emit('defaultSearchItemsChange', this.defaultSearchItems)
        this.perConfigs = result[1].data
        if (
          !this.perConfigs ||
          this.perConfigs.length === 0 ||
          !this.perConfigs.find(item => item.bDefault)
        ) {
          this.fillGlobalConfig()
          this.perConfig.configName = 'default'
        }
        this.fillPerConfig()
        this.canOptMoreBtn = true
      } catch (err) {
        console.error('错误' + this.configModule, err)
        this.$message.error(
          this.$t('Message.AdvancedSchemeLoadingFailed01') + this.configModule + err
        )
      }
    },
    selectedPerConfigByBtn(val) {
      this.selectedPerConfig(val)
    },
    selectedPerConfigByCommand(val) {
      console.log(this.perConfigs)
      if (val === 'manage') {
        this.showSaveAsDialog()
        return
      }
      this.selectedPerConfig(val)
    },
    selectedPerConfig(val) {
      if (
        val === 'default' &&
        (!this.perConfigs ||
          this.perConfigs.length === 0 ||
          !this.perConfigs.find(item => item.bDefault))
      ) {
        this.fillGlobalConfig()
      } else {
        const selectedItem = this.perConfigs.find(item => {
          if (val === 'default') {
            return item.bDefault
          }
          return item.id === val
        })

        if (!selectedItem) {
          this.$message.error(this.$t('Message.TheFoundPleaseSelectScheme'))
          return
        }
        this.selectedConfigValue = val
        this.perConfig.configName = selectedItem.configName
        this.fillPerConfig(selectedItem.configName)
      }
      // 切换方案
      this.$emit('switchScheme')
      this.$emit('schemeChange', this.perConfig ? this.perConfig.configName : '')
    },
    // end

    // begin------保存默认查询条件------
    showSaveModifiedDialog() {
      if (this.gridConfigModule) {
        const currentUserInfo = getUserInfo()
        const perColumnState = localStorage.getItem(`local_uiDoc_person_gridStatus_${currentUserInfo.tenantId}_${currentUserInfo.userId}_${this.gridConfigModule}_${this.perConfigName}`)
        this.saveModifiedDialog.isSaveColumnState = !!perColumnState
        this.saveModifiedDialog.visible = true
      } else {
        this.saveScheme()
      }
    },
    async doSaveModified() {
      await this.saveScheme()
      const currentUserInfo = getUserInfo()
      const configName = `local_uiDoc_person_gridStatus_${currentUserInfo.tenantId}_${currentUserInfo.userId}_${this.gridConfigModule}_${this.perConfigName}`
      let perColumnState = localStorage.getItem(configName + '_temp')
      if (!perColumnState) {
        perColumnState = localStorage.getItem(configName)
      }
      if (this.saveModifiedDialog.isSaveColumnState) {
        if (!perColumnState) {
          perColumnState = this.getDefaultColumnState()
        }
        if (perColumnState) {
          const data = {
            bDefault: true,
            configModule: this.gridConfigModule,
            configType: 2, // 固定值，表格配置
            configName,
            configContent: perColumnState,
            configBy: currentUserInfo.userId
          }
          await savePersonQueryConfig(data)
          localStorage.setItem(configName, perColumnState)
          this.$emit('refreshGrid')
        }
      } else {
        if (perColumnState) {
          await delPerConfigByIdOrConfigName({ configName })
          localStorage.removeItem(configName)
          this.$emit('refreshGrid')
        }
      }
      this.saveModifiedDialog.visible = false
    },
    getDefaultColumnState() {
      const currentUserInfo = getUserInfo()
      let defaultColumnState = localStorage.getItem(`local_uiDoc_person_gridStatus_${currentUserInfo.tenantId}_${currentUserInfo.userId}_${this.gridConfigModule}`)
      if (!defaultColumnState) {
        defaultColumnState = localStorage.getItem(`local_uiDoc_init_gridStatus_${currentUserInfo.tenantId}_${currentUserInfo.userId}_${this.gridConfigModule}`)
      }
      return defaultColumnState
    },
    async saveScheme() {
      console.log(this.perConfig)
      if (this.perConfig.configName === this.defConfig.configName) {
        this.perConfig.bDefault = true
      } else {
        this.perConfig.bDefault = false
      }
      this.perConfig.configContent = this.pureSchemeBeforeSave(
        lodash.cloneDeep(this.multipleSelection)
      )
      // 如果已经有用户的默认配置了，那么后台应该去更新default配置
      await this.savePerConfigPost()
    },
    // end

    // begin-----保存查询模板-------
    async saveAs() {
      // 方案名不能重复
      const index = this.perConfigs.findIndex(item => {
        return item.configName === this.searchTemplate.label
      })
      if (index > -1) {
        await this.$confirm(this.$t('Message.AlreadyExistsOverwriteOriginalScheme'), this.$t('Message.Prompt'), {
          type: 'warning'
        })
        await this.toSave()
      } else if (!this.searchTemplate.label.trim()) {
        this.$message.error(this.$t('CargoMsg.Cargo_PleaseEnterPlanName'))
      } else {
        await this.toSave()
      }
    },
    pureSchemeBeforeSave(multipleSelection) {
      // const pureConfigs = []
      // todo 可根据配置判断是否要覆盖
      /* multipleSelection.forEach(ms => {
        if (this.customSearchItems.find(cs => (ms.itemName === cs.itemName))) {
          ms.valueExpression = {}
        }
      })*/
      const pureConfigs = multipleSelection.filter(item => {
        // item.itemCondition = []
        // item.defaultConditionVal = ''
        // 设置默认值
        item.defaultValue = item.itemValue
        item.itemValue = ''
        // todo
        // item.valueExpression={}
        // pureConfigs.push(item)

        // todo 应删除 额外自定义的扩展的的searchItem
        return item
      })

      return pureConfigs
    },
    async toSave() {
      // this.isShowSaveAs = false
      this.perConfig.bDefault = false
      this.perConfig.configContent = this.pureSchemeBeforeSave(
        lodash.cloneDeep(this.multipleSelection)
      )
      // 配置名称不可重复
      this.perConfig.configName = this.searchTemplate.label
      await this.savePerConfigPost()
    },
    async savePerConfigPost() {
      try {
        await savePersonQueryConfig({
          ...this.perConfig,
          configContent: JSON.stringify(this.perConfig.configContent)
        })
        this.isShowAbc = false
        this.isShowSaveAs = false
        this.$message.success(this.$t('CargoMsg.Cargo_SchemeSaveSuccess'))
        return await this.getPerConfigs(this.perConfig.configName) // 重新查询刚配置的方案
      } catch (err) {
        this.$message.error(err)
        throw err
      }
    },
    getPerConfigs(configName = null) {
      // 获取个人配置方案
      return getPersonQueryConfig({
        configType: 1,
        configModule: this.configModule
      })
        .then(res => {
          this.perConfigs = res.data
          this.fillPerConfig(configName)
        })
        .catch(err => {
          // console.log('==searchItem 操作个人方案失败 err  ', err)
          return Promise.reject(err)
        })
    },
    // 填充个人配置的默认检索条件
    fillPerConfig(configName = null, watchCustomSearchItems) {
      this.perConfigs.sort((a, b) => {
        return a.configName.localeCompare(b.configName, 'zh-CN', {
          numeric: true
        })
      })
      console.log(this.perConfigs)
      const config = this.perConfigs.find(item => {
        if (configName) {
          return item.configName === configName
        } else {
          return item.bDefault === true
        }
      })
      if (this.retainDefaultValue) {
        const defaultItemValue = []
        this.multipleSelection.forEach(eve => {
          if (typeof eve.itemValue !== 'object' && eve.itemValue) {
            defaultItemValue.push(eve)
          } else if (typeof eve.itemValue === 'object' && eve.itemValue && eve.itemValue.length > 1) {
            defaultItemValue.push(eve)
          }
        })
        if (watchCustomSearchItems) {
          // 说明不是被 全局global调用的，方式 全局默认设置不生效
          // this.multipleSelection = []
          const searchItems = lodash.cloneDeep(this.defaultSearchItems)
          this.preProcessSearchItem(searchItems, true)
          this.searchItems = this.supplementSearchItems(searchItems, true)
          // this.mergePerConfigIntoSearchItems(JSON.parse(config.configContent))
          const configContents = this.mergePerConfigWithSearchItems(
            lodash.cloneDeep(this.multipleSelection)
          ) //
          this.preProcessSearchItem(configContents)
          this.multipleSelection = this.supplementSearchItems(configContents)
          this.perConfig.configName = 'default'
          this.$nextTick(() => {
            this.multipleSelection.forEach(eve => {
              defaultItemValue.map(e => {
                if (eve.itemName === e.itemName) {
                  eve.itemValue = e.itemValue
                }
              })
            })
          })
          this.toInitSopStateTrackSearchItem()
          return
        }
        if (config) {
          // this.multipleSelection = []
          const searchItems = lodash.cloneDeep(this.defaultSearchItems)
          this.preProcessSearchItem(searchItems, true)
          this.searchItems = this.supplementSearchItems(searchItems, true)
          // this.mergePerConfigIntoSearchItems(JSON.parse(config.configContent))
          const configContents = this.mergePerConfigWithSearchItems(
            JSON.parse(config.configContent)
          )
          this.preProcessSearchItem(configContents)
          this.multipleSelection = this.supplementSearchItems(configContents)
          this.selectedConfigValue = config.id
          this.perConfig.configName = config.configName
          this.toInitSopStateTrackSearchItem()
        }
      } else {
        if (config) {
          // this.multipleSelection = []
          const searchItems = lodash.cloneDeep(this.defaultSearchItems)
          this.preProcessSearchItem(searchItems, true)
          this.searchItems = this.supplementSearchItems(searchItems, true)
          // this.mergePerConfigIntoSearchItems(JSON.parse(config.configContent))
          const configContents = this.mergePerConfigWithSearchItems(
            JSON.parse(config.configContent)
          )
          this.preProcessSearchItem(configContents)
          this.multipleSelection = this.supplementSearchItems(configContents)
          this.selectedConfigValue = config.id
          this.perConfig.configName = config.configName
        } else if (watchCustomSearchItems) {
          // 说明不是被 全局global调用的，方式 全局默认设置不生效
          // this.multipleSelection = []
          const searchItems = lodash.cloneDeep(this.defaultSearchItems)
          this.preProcessSearchItem(searchItems, true)
          this.searchItems = this.supplementSearchItems(searchItems, true)
          // this.mergePerConfigIntoSearchItems(JSON.parse(config.configContent))
          const configContents = this.mergePerConfigWithSearchItems(
            lodash.cloneDeep(this.multipleSelection)
          ) //
          this.preProcessSearchItem(configContents)
          this.multipleSelection = this.supplementSearchItems(configContents)
          this.perConfig.configName = 'default'
        }
        this.toInitSopStateTrackSearchItem()
      }
    },
    fillGlobalConfig() {
      const searchItems = lodash.cloneDeep(this.defaultSearchItems)
      this.preProcessSearchItem(searchItems, true)
      this.searchItems = this.supplementSearchItems(searchItems, true)
      //
      this.assembleGlobalDefaultScheme()
      this.perConfig.configName = 'default'
    },
    keyWordCharge() {
      const keyWords = this.keyWords ? this.keyWords.trim() : ''
      this.$emit('keyWordCharge', keyWords)
    },
    simSearch() {
      const keyWords = this.keyWords ? this.keyWords.trim() : ''
      if (!keyWords || keyWords.length === 0) {
        let message = this.$t('CargoMsg.Cargo_PlsInput')
        const simQueryPlaceholder = this.simQueryPlaceholderValue
        if (
          simQueryPlaceholder &&
          simQueryPlaceholder.split(':').length === 2
        ) {
          message = message + simQueryPlaceholder.split(':')[1]
        }
        this.$message.warning(message)
        return
      }
      this.$emit('simSearchItemCallBack', keyWords)
      this.$emit('query', { conditions: keyWords, simpleTriggerMode: true })
      this.preQueryMode = 'simple'
      if (this.searchItemMode === 'querydata') {
        // const params = { params: { keyword: encodeURIComponent((JSON.stringify(this.keyWords))) }}
        // pageSize 页尺 pageNum 页码 sort 排序（？后面传参）
        this.getSimQueryResult({ keyword: keyWords })
      }
    },
    getSimQueryResult(params) {
      this.preQueryMode = 'simple'
      getSimQueryResult(this.simUrl, params)
        .then(res => {
          // console.log('getSimSearchRequest', res.data)
          this.$emit('queryDataCallBack', res.data)
        })
        .catch(err => {
          this.$message.error(err)
        })
    },
    getAdvRequestData() {
      return this.toDealAdvRequestData()
    },
    // todo-shengsheng  Desc: 该方法需要优化-不好维护
    toDealAdvRequestData() {
      const requestData = []
      const sourceData = lodash.cloneDeep(this.multipleSelection)
      this.multipleSelection.forEach(item => {
        if (item.cascade) {
          // 这个级联的处理，是对于财务综合查询的 船名航次的简单场景，其他级联复杂场景，请扩展
          sourceData.push(item.cascade)
        }
      })
      lodash.forEach(sourceData, item => {
        // this.$logger.log('toDealAdvRequestData value 处理前', 'fieldType', item.fieldType, 'itemName', item.itemName, 'itemValue', value, 'itemType', item.itemType, 'operator', item.defaultConditionVal, item.itemCondition)
        let operator = item.defaultConditionVal
        if (operator === AdvancedSearchConsts.OPERATOR_IS_IT_EMPTY.code) {
          if (typeof item.itemValue === 'boolean') {
            if (item.itemValue) {
              operator = 'IS NULL'
            } else {
              operator = 'IS NOT NULL'
            }
          } else {
            return
          }
        }
        if (operator === AdvancedSearchConsts.OPERATOR_IS_IT_NOT_EMPTY.code) {
          if (typeof item.itemValue === 'boolean') {
            if (item.itemValue) {
              operator = 'IS NOT NULL'
            } else {
              operator = 'IS NULL'
            }
          } else {
            return
          }
        }
        let value = item.itemValue
        // 业务状态处理
        if (item.dataCacheKey === 'local_cache_SystemConstants$JOB_STATES') {
          value = this.handleJobStates(item)
        }
        if (typeof value === 'string') {
          value = value.trim()
        }
        if (
          operator &&
          operator !== AdvancedSearchConsts.OPERATOR_IS_NOT_NULL.code &&
          operator !== AdvancedSearchConsts.OPERATOR_IS_NULL.code
        ) {
          // 1、从数据类型维度上做处理
          // bigdecimalrange预处理
          if (
            item.itemType === 'input' &&
            (item.subType === 'bigdecimalrange' ||
              item.subType === 'bigdecimalrangeForPositive' ||
              item.subType === 'bigdecimalrangeWithPrecision')
          ) {
            if (
              item.itemValue1 ||
              item.itemValue1 === 0 ||
              item.itemValue2 ||
              item.itemValue2 === 0
            ) {
              value = [item.itemValue1, item.itemValue2]
            } else {
              value = []
            }
          }
          // charRange
          if (item.itemType === 'input' && item.subType === 'charRange') {
            if (item.itemValue1) item.itemValue1 = item.itemValue1.trim()
            if (item.itemValue2) item.itemValue2 = item.itemValue2.trim()
            value = [item.itemValue1, item.itemValue2]
          }
          // input-m预处理
          if (item.itemType === 'input-m') {
            if (item.itemValue) {
              value = item.itemValue.split(/[\n]/g)
            } else {
              value = []
            }
          }
          // Number最大16位，超过16，转换出来的结果也是错误的;如果超过16位，就不做转Number处理
          if (
            !isArray(value) &&
            isNumber2(value) &&
            !['FIELD_MULTI_TEXT', 'FIELD_TEXT', 'FIELD_TEXT4', 'FIELD_MULTI_EXCLUDE_TEXT', 'FIELD_MULT_TEXT3', 'FIELD_MULTI_DROP_DOWN_LIST_NOT_CONVERT'].includes(item.fieldType) &&
            item.defaultConditionVal !== 'DATE ITEM' &&
            value.length <= 16
          ) {
            // FIELD_TEXT文本类型的，不进行 数字类型转换
            value = Number(value)
          }
          // 值校验
          if (operator === AdvancedSearchConsts.OPERATOR_UNEQUAL.code && isArray(value) && value.length > 1) {
            value = [value[0]]
          }
          if (isArray(value)) {
            if (value.length === 0) {
              if (operator !== AdvancedSearchConsts.OPERATOR_UNEQUAL.code) {
                return
              }
              value = ''
            } else if (
              value.findIndex(
                v => v !== null && v !== '' && v !== undefined
              ) === -1
            ) {
              if (operator !== AdvancedSearchConsts.OPERATOR_UNEQUAL.code) {
                return
              }
              value = ''
            }
          } else if (!isNumber2(value) && !value && typeof value !== 'boolean') {
            if (operator !== AdvancedSearchConsts.OPERATOR_UNEQUAL.code) {
              return
            }
            value = ''
          }
          // 2、从fieldType维度上做处理校验
          // 根据选择的数据，转换操作符
          if (item.fieldType === 'FIELD_IS_NOT_NULL') {
            operator = value
              ? AdvancedSearchConsts.OPERATOR_IS_NOT_NULL.code
              : AdvancedSearchConsts.OPERATOR_IS_NULL.code
          } else if (item.fieldType === 'FIELD_IS_NOT_ZERO') {
            operator = value
              ? AdvancedSearchConsts.OPERATOR_EQUAL.code
              : AdvancedSearchConsts.OPERATOR_UNEQUAL.code
            if (item.itemName === 'job.BOOKING_AGENT') {
              value = false // 订舱代理为空，是 相当于 订舱代理等于0， 否 则不等于0
            }
          } else if (item.fieldType === 'FIELD_CHECKBOX') {
            // 配置的是什么类型 ，就是什么，不进行二次转换
            // value = value ? 1 : 0
          } else if (item.fieldType === 'FIELD_SETTLEMENT_TYPE') {
            if (value === -1) return
          } else if (item.fieldType === 'FIELD_MULT_TEXT2') {
            if (item.subType && item.subType === 'string') {
              value = value ? String(value) : value
            }
          }

          if (item.itemType === 'sopStateTrack') {
            // 状态追踪
            value = this.toConvertSopStateTrackValue(item)
            item.itemName = 'trackingInfo._multipleState_'
            item.fieldType = 'trackingMultiple'
          } else {
            switch (operator) {
              case '=':
              case '!=':
              case '>=':
              case '<=':
              case 'LIKE':
              case 'NOT LIKE':
              case 'IN':
              case 'NOT IN':
              case 'REGEXP':
                break
              case 'IS NOT NULL':
              case 'IS NULL':
                break
              case 'BATCH':
                value = String(value).split(',')
                break
              case 'BATCH_EXCLUDE':
                value = String(value).split(',')
                break
              case 'RANGE': {
                let type = ''
                let start = ''
                let end = ''
                if (item.itemType === 'date') {
                  type = 'date'
                  // 同一天的处理
                  if (value[0] && !value[0].includes(' 00:00:00')) {
                    value[0] = value[0].trim() + ' 00:00:00'
                  }
                  if (value[1] && !value[1].includes(' 23:59:59')) {
                    value[1] = value[1].trim() + ' 23:59:59'
                  }
                  // subtype=range
                } else if (
                  item.subType === 'bigdecimalrange' ||
                  item.subType === 'bigdecimalrangeForPositive' ||
                  item.subType === 'bigdecimalrangeWithPrecision'
                ) {
                  type = 'double'
                } else {
                  type = 'string'
                }
                if (value[0] || isNumber(value[0])) {
                  start = `,start=${value[0]}`
                }
                if (value[1] || isNumber(value[1])) {
                  end = `,end=${value[1]}`
                }
                value = `type=${type}${start}${end}`
                break
              }
              case 'DATE ITEM': {
                let start = ''
                let end = ''
                value = this.getDateItemRange(value)
                if (value[0] || isNumber(value[0])) {
                  start = `,start=${value[0]}`
                }
                if (value[1] || isNumber(value[1])) {
                  end = `,end=${value[1]}`
                }
                value = `type=date${start}${end}`
                break
              }
              default:
                return
            }
          }
        } else if (item.isCascade !== true) {
          value = operator
        }
        if (item.subType === 'cascaderMulti' && value && value.length > 0) {
          let finalValue = []
          value.forEach(obj => {
            finalValue = [...finalValue, obj[obj.length - 1]]
          })
          value = finalValue
        }
        // this.$logger.log('toDealAdvRequestData value 处理后', 'itemName', item.itemName, 'itemValue', value, 'itemType', item.itemType, 'operator', operator)
        requestData.push({
          fieldType: item.fieldType,
          fieldName: item.itemName,
          operator: operator === 'DATE ITEM' ? 'RANGE' : operator,
          value
        })
      })
      console.log('requestData', requestData)
      return requestData
    },
    advSearch() {
      const advRequestData = lodash.cloneDeep(this.getAdvRequestData())
      if (this.isAppendQuery) {
        advRequestData.push({
          appendQuery: this.appendQuery
        })
      }
      if (this.isBranchCooperate) {
        advRequestData.push({
          branchCooperate: this.branchCooperate
        })
      }
      this.$emit('advSearchItemCallBack', advRequestData)
      this.$emit('query', {
        conditions: advRequestData,
        simpleTriggerMode: false
      })
      this.preQueryMode = 'adv'
      if (this.searchItemMode === 'querydata') {
        // const params = { keyCode: '', params: encodeURIComponent((JSON.stringify(this.multipleSelection))) }
        this.getAdvQueryResult(advRequestData)
      }
    },
    advExport() {
      const advRequestData = lodash.cloneDeep(this.getAdvRequestData())
      if (this.isAppendQuery) {
        advRequestData.push({
          appendQuery: this.appendQuery
        })
      }
      if (this.isBranchCooperate) {
        advRequestData.push({
          branchCooperate: this.branchCooperate
        })
      }
      this.$emit('advSearchExportCallBack', advRequestData)
    },
    getAdvQueryResult(data) {
      this.preQueryMode = 'adv'
      getAdvQueryResult(this.advUrl, data)
        .then(res => {
          if (res.ok) {
            this.$emit('queryDataCallBack', res.data)
          } else {
            return Promise.reject(res.message)
          }
        })
        .catch(err => {
          this.$message.error(err)
        })
    },
    handleSelectionChange(val) {},
    toChooseAllSearchItem() {
      // 全选
      this.searchItems.forEach(row => {
        if (
          this.filteredSearchItems.findIndex(item => {
            return (
              item.itemName === row.itemName &&
              item.itemType === row.itemType &&
              item.fieldType === row.fieldType
            )
          }) > -1
        ) {
          row.selected = 1
        }
      })
      this.multipleSelection = this.searchItems.filter(row => {
        return row.selected
      })
    },
    toInvertChooseSearchItem() {
      // 反选
      this.searchItems.forEach(row => {
        if (
          this.filteredSearchItems.findIndex(item => {
            return (
              item.itemName === row.itemName &&
              item.itemType === row.itemType &&
              item.fieldType === row.fieldType
            )
          }) > -1
        ) {
          if (!row.lock) {
            row.selected = !row.selected
          } else {
            row.selected = 1
          }
        }
      })
      this.multipleSelection = this.searchItems.filter(row => {
        return row.selected
      })
    },
    selectRow(index, rows) {
      const selectRow = this.filteredSearchItems[index]
      // console.log('selectRow', selectRow)
      const hasChoose =
        this.multipleSelection.findIndex(item => {
          return (
            item.itemName === selectRow.itemName &&
            item.itemType === selectRow.itemType &&
            item.fieldType === selectRow.fieldType
          )
        }) > -1
      if (hasChoose) {
        this.$message.warning(
          this.$t('CargoMsg.Cargo_TheQueryItemSelected', [
            `${this.$t(selectRow.itemLabel)}`
          ])
        )
      } else {
        this.multipleSelection.push(selectRow)
        selectRow.selected = 1
      }
    },
    deleteSearchItem(index, rows) {
      // const obj = this.multipleSelection[index]
      // console.log('obj', obj)
      rows.splice(index, 1)
      this.multipleSelection = rows
      this.multipleSelection.forEach(item => {
        if (item.itemType === 'select' && item.multiple) {
          const ref = `${item.itemName}${item.itemType}${this.selectedConfigValue}`
          this.convertSelectedToText(ref)
        }
      })
    },
    async deleteRowSearchTemplate(index, rows) {
      await this.$confirm(this.$t('Message.AreYouWantToDelete'), this.$t('Message.Tip'), { type: 'warning' })
      const obj = this.perConfigs[index]
      try {
        let isContinue = true
        if (this.gridConfigModule) {
          const currentUserInfo = getUserInfo()
          const configName = `local_uiDoc_person_gridStatus_${currentUserInfo.tenantId}_${currentUserInfo.userId}_${this.gridConfigModule}_${obj.configName}`
          const perColumnState = localStorage.getItem(configName)
          if (perColumnState) {
            await delPerConfigByIdOrConfigName({ id: obj.id, configName })
            localStorage.removeItem(configName)
            if (this.perConfigName === obj.configName) {
              this.$emit('refreshGrid')
            }
            isContinue = false
          }
        }
        if (isContinue) {
          await delPersonQueryConfig(obj.id)
        }
      } catch (err) {
        this.$message.error(this.$t('Message.DeleteSchemeFailed') + err)
        throw err
      }
      rows.splice(index, 1)
    },
    moveDown(index, rows) {
      const obj = this.multipleSelection[index]
      this.multipleSelection.splice(index, 1)
      this.multipleSelection.splice(index + 1, 0, obj)
      // rows.splice(index, 1)
    },
    moveUp(index, rows) {
      const obj = this.multipleSelection[index]
      this.multipleSelection.splice(index, 1)
      this.multipleSelection.splice(index - 1, 0, obj)
    },
    onAdvSelectEnter() {
      // cargoAdvanceSelect组件 点击确定时，调用高级查询
      // todo
      console.log('=====@keydown.native.enter.prevent="onAdvSelectEnter"====')
    },
    paymentTermOptionLabel(item) {
      return ColumnUtils.paymentTermLabelFunc(item && item.code)
    },
    getValueFromChild(data) {
      this.multipleSelection = lodash.map(this.multipleSelection, item => {
        // console.log('item', item.itemName, item.itemType)
        // console.log('data', data.refCode, data.itemType)
        if (
          item.itemName === data.refCode &&
          (item.itemType === data.itemType || !data.itemType) &&
          (item.fieldType === data.fieldType || !data.fieldType)
        ) {
          // console.log('(typeof data.value )', (typeof data.value))
          // 组件多选的情况，data.value 是个数组
          // （此处 data如果是个对象，是一定要有value和chineseName属性。为了结构统一，可在cargo-advance-select返回时） 2020/9/17 data.value 不要转字符串
          item.itemValue =
            typeof data.value === 'object' ? data.value : data.value
          if (item.itemType === 'paymentTerm') {
            item.itemContent = Array.isArray(item.itemValue)
              ? item.itemValue.map(value => ColumnUtils.paymentTermLabelFunc(value)).filter(Boolean).join(',')
              : ColumnUtils.paymentTermLabelFunc(item.itemValue)
          } else {
            item.itemContent = (this.$store.getters.language === 'zh' ? data.chineseName : data.englishName) || ''
          }
          // 把itemContent 存个对象，解决 options项某些列为空的情况
          // item.itemContent = data || {}
        }
        if (item.changeEvent) {
          // 触发自定义事件
          this.$emit(item.changeEvent, item.itemValue)
        }
        return item
      })
    },
    toConvertSopStateTrackValue(item) {
      return item.richItemValue
    },
    toClearSopStateTrack(item) {
      this.sopStateTrack.dialog.currentValue = deepClone(
        this.sopStateTrack.dialog.initCurrentValue
      )
      this.sopStateTrack.cache.set(this.sopStateTrack.currentItem.itemName + this.sopStateLob, this.sopStateTrack.dialog.currentValue)

      // 同步下拉框 与text 值
      this.sopStateTrack.dialog.data.forEach((item, index) => {
        this.convertSelectedToText(`track${index}`)
      })

      item.itemValue = {}
      item.richItemValue = {}
      item.txtContent = ''
      if (this.sourcePage === 'sales' || this.sourcePage === 'finance') {
        this.$emit('sopStateCallBack', '')
      }
    },
    toResetSopStateTrack() {
      this.sopStateTrack.dialog.currentValue = deepClone(
        this.sopStateTrack.dialog.initCurrentValue
      )
      this.sopStateTrack.cache.clear()
      this.sopStateTrack.dialog.data.forEach((item, index) => {
        this.convertSelectedToText(`track${index}`)
      })
    },
    toInitSopStateTrackSearchItem() {
      const currentItem = this.multipleSelection.find(
        item => item.itemType === 'sopStateTrack'
      )
      this.sopStateTrack.currentItem = currentItem || {}
    },
    async toShowSopStateTrack(item) {
      console.log('toShowSopStateTrack')
      this.loading = getLoading()
      try {
        await this.fetchSopStateTrackData()
        this.sopStateTrack.isShow = true
        this.sopStateTrack.currentItem = item
        this.sopStateTrack.dialog.operator =
          item.richItemValue.operator || 'and'
        let currentValue = this.sopStateTrack.cache.get(item.itemName + this.sopStateLob)
        if (!currentValue) {
          currentValue = {
            ...deepClone(this.sopStateTrack.dialog.initCurrentValue),
            ...item.itemValue
          }
        }
        this.sopStateTrack.dialog.currentValue = currentValue

        this.$nextTick(() => {
          // 同步下拉框 与text 值
          this.sopStateTrack.dialog.data.forEach((item, index) => {
            this.convertSelectedToText(`track${index}`)
          })
        })

        this.loading.close()
      } catch (err) {
        this.loading.close()
      }
    },
    toConfirmEditSopStateTrack() {
      this.sopStateTrack.cache.set(this.sopStateTrack.currentItem.itemName + this.sopStateLob, this.sopStateTrack.dialog.currentValue)
      this.sopStateTrack.isShow = false
      const {
        values,
        content,
        richItemValue
      } = this.toComputeStateTrackValAndContent()
      this.sopStateTrack.currentItem.itemValue = values
      this.sopStateTrack.currentItem.richItemValue = richItemValue
      this.sopStateTrack.currentItem.txtContent = content
      if (this.sourcePage === 'sales' || this.sourcePage === 'finance') {
        this.originalTruckingData.rowData = this.sopStateTrack.dialog.data
        this.originalTruckingData.lob = this.sopStateLob
        this.$emit('sopStateCallBack', this.sopStateLob)
      }
    },
    toComputeStateTrackValAndContent() {
      const values = {}
      let content = ''
      const richItemValue = {
        value: [],
        operator: this.sopStateTrack.dialog.operator
      }
      Object.entries(this.sopStateTrack.dialog.currentValue).forEach(
        ([tCode, tdCodeArr]) => {
          if (tdCodeArr.length > 0) {
            values[tCode] = [...tdCodeArr]
            // content += tCode
          }
        }
      )
      const tCodes = Object.keys(values)
      this.sopStateTrack.dialog.data.forEach(item => {
        if (tCodes.includes(item.code)) {
          const tempValue = { code: '', name: '', details: [] }
          if (content) {
            content += ` ${this.sopStateTrack.dialog.operator} `
          }
          tempValue.code = item.code
          tempValue.name = item.codeCname
          content += item.codeCname + '('
          const tempContent = []
          item.trackingDetail.forEach(td => {
            if (values[item.code].includes(td.code)) {
              tempContent.push(td.codeCname)
              tempValue.details.push({ code: td.code, name: td.codeCname })
            }
          })
          content += tempContent.join(',')
          content += ')'
          richItemValue.value.push(tempValue)
        }
      })
      return { values, content, richItemValue }
    },
    toCancelEditSopStateTrack() {
      this.sopStateTrack.cache.set(this.sopStateTrack.currentItem.itemName + this.sopStateLob, this.sopStateTrack.dialog.currentValue)
      if (this.sourcePage === 'sales' || this.sourcePage === 'finance') {
        this.sopStateTrack.dialog.data = this.originalTruckingData.rowData
        this.sopStateLob = this.originalTruckingData.lob
      }
      this.sopStateTrack.isShow = false
    },
    toShowEditTextArea(inputItem) {
      this.isShowEditTextArea = true
      this.currentInputItem = inputItem
      this.dialogTextAreaValue = inputItem.itemValue
    },
    toConfirmEditTextArea() {
      this.isShowEditTextArea = false
      this.currentInputItem.itemValue = this.dialogTextAreaValue
      this.currentInputItem = {}
    },
    toCancelEditTextArea() {
      this.isShowEditTextArea = false
      this.currentInputItem = {}
      this.dialogTextAreaValue = ''
    },
    toGetMyFocus() {
      this.getSimQueryResult({ bFocus: true })
    },
    upOrDownSearchCondition() {
      this.isShowingMoreSearchCondition = !this.isShowingMoreSearchCondition
      if (this.recordExpandStatus) {
        LocalStorageUtilsNew.setConfiguration('expandStatus-' + this.configModule, this.isShowingMoreSearchCondition)
      }
      this.$emit('click-more', this.isShowingMoreSearchCondition)
      this.$emit('update:isSimpleQuery', !this.isShowingMoreSearchCondition)
      // console.log('isShowingMoreSearchCondition', this.isShowingMoreSearchCondition)
    },
    toSetValueForSearch(values) {
      // 为查询条件设置指定值（类似静态值）
      // values=> 数组 自定义组件=》[{itemName:'',itemValue:'',itemContent:''}]
      //  input类型=》{itemName:'',itemValue1:'',itemValue2:''}
      //  element组件类型=》{itemName:'',itemValue:''}
      const items = []
      this.multipleSelection.forEach(item => {
        let tempItem = values.find(val => {
          return item.itemName === val.itemName
        })
        if (tempItem) {
          tempItem = { ...item, ...tempItem }
        } else {
          // todo
          tempItem = { ...item }
        }
        items.push(tempItem)
      })
      this.multipleSelection = [...items]
    },
    toResetSearch() {
      // 清空比重置更合适 todo ,如果重置的话，可以 load一遍 方案 （load一遍方案，比较有局限性，不采取）
      // this.$refs.searchForm.resetFields() // 不能用element 提供的方法
      const items = []
      this.multipleSelection.forEach(item => {
        item.itemValue =
          typeof item.defaultValue === 'object'
            ? lodash.cloneDeep(item.defaultValue)
            : item.defaultValue
        items.push(item)
      })
      this.multipleSelection = [...items]
      this.$emit('advSearchItemResetCallBack', this.getAdvRequestData())
    },
    toResetFields() {
      console.log('this.multipleSelection', this.multipleSelection)
      this.multipleSelection.forEach((item, index) => {
        if (!(item.lock || item.fixed || item.fix)) {
          if (
            item.subType === 'bigdecimalrange' ||
            item.subType === 'bigdecimalrangeForPositive' ||
            item.subType === 'bigdecimalForPositive' ||
            item.subType === 'charRange' ||
            item.subType === 'bigdecimalrangeWithPrecision'
          ) {
            item.itemValue = undefined // null
            item.itemValue1 = undefined // null
            item.itemValue2 = undefined // null
          } else if (item.itemType === 'date' && item.subType === 'range') {
            item.itemValue = []
          } else {
            item.itemValue = null
          }
          if (item.itemType === 'stateTypes' || item.itemType === 'select') {
            this.manualCleanSelect(item)
          }
          // 重置条件时清空sop查询框
          if (item.itemType === 'sopStateTrack') {
            this.toClearSopStateTrack(item)
          }
          // 重置条件时清空EDI状态查询框    || 清空对账新版中的业务模式
          if (item.itemType === 'ediStateQuery' || item.itemType === 'containerLoadTypeCascader') {
            this.toClearSpecialQuery(item)
          }
        }
        // this.$set(this.multipleSelection, index, item)
      })
      this.appendQuery = false
      this.$emit('resetFields', this.multipleSelection)
    },
    async manualCleanSelect(item) {
      await ensureExecuteSuccess(() => this.$refs[`${item.itemName}${item.itemType}${this.selectedConfigValue}`])
      const selectRef = this.$refs[
        `${item.itemName}${item.itemType}${this.selectedConfigValue}`
      ]
      const curSelect = Array.isArray(selectRef) ? selectRef[0] : selectRef
      if (curSelect && curSelect.multiple) {
        const tagWrapper = curSelect.$el.querySelector('.el-select__tags>span')
        if (tagWrapper) {
          tagWrapper.innerHTML = null
        }
      }
    },
    showSaveSchemeDialog() {
      if (this.gridConfigModule) {
        this.saveSchemeDialog.name = ''
        this.saveSchemeDialog.isSaveColumnState = false
        this.saveSchemeDialog.visible = true
      } else {
        this.createNew()
      }
    },
    async doSaveScheme() {
      if (this.saveSchemeDialog.isSaveColumnState) {
        const currentUserInfo = getUserInfo()
        const sourceConfigName = `local_uiDoc_person_gridStatus_${currentUserInfo.tenantId}_${currentUserInfo.userId}_${this.gridConfigModule}_${this.perConfigName}`
        let perColumnState = localStorage.getItem(sourceConfigName + '_temp')
        if (!perColumnState) {
          perColumnState = localStorage.getItem(sourceConfigName)
        }
        if (!perColumnState) {
          perColumnState = this.getDefaultColumnState()
        }
        if (perColumnState) {
          const targetConfigName = `local_uiDoc_person_gridStatus_${currentUserInfo.tenantId}_${currentUserInfo.userId}_${this.gridConfigModule}_${this.saveSchemeDialog.name}`
          const data = {
            bDefault: true,
            configModule: this.gridConfigModule,
            configType: 2, // 固定值，表格配置
            configName: targetConfigName,
            configContent: perColumnState,
            configBy: currentUserInfo.userId
          }
          await savePersonQueryConfig(data)
          localStorage.setItem(targetConfigName, perColumnState)
        }
      }
      this.searchTemplate.label = this.saveSchemeDialog.name
      await this.saveAs()
      this.saveSchemeDialog.visible = false
    },
    createNew() {
      this.$prompt(
        this.$t('CargoMsg.Cargo_SchemeName'),
        this.$t('CargoMsg.Cargo_NewQueryScheme'),
        {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel')
        }
      ).then(({ value }) => {
        this.searchTemplate.label = value
        this.saveAs()
      })
    },
    convertSelectedToText(ref) {
      this.$nextTick(() => {
        const selectRef = this.$refs[ref]
        const curSelect = Array.isArray(selectRef) ? selectRef[0] : selectRef
        if (!curSelect || !curSelect.$el) {
          return
        }
        if (curSelect.multiple && curSelect.selected) {
          const selected = curSelect.selected.map(item => {
            return item.$el.innerText
          })
          const tagWrapper = curSelect.$el.querySelector(
            '.el-select__tags>span'
          )
          if (tagWrapper) {
            tagWrapper.innerHTML = selected.length
              ? `<span>${selected.join(',')}</span>`
              : ''
          }
        }
      })
    },
    getDateItemRange(value) {
      const range = []
      switch (value) {
        case -1:
          range[0] = moment().format('YYYY-MM-DD')
          range[1] = moment().format('YYYY-MM-DD')
          break
        case 0:
          range[0] = moment()
            .week(moment().week())
            .startOf('isoWeek')
            .format('YYYY-MM-DD')
          range[1] = moment()
            .week(moment().week())
            .endOf('isoWeek')
            .format('YYYY-MM-DD')
          break
        case 1:
          range[0] = moment()
            .week(moment().week() - 1)
            .startOf('isoWeek')
            .format('YYYY-MM-DD')
          range[1] = moment()
            .week(moment().week() - 1)
            .endOf('isoWeek')
            .format('YYYY-MM-DD')
          break
        case 2:
          range[0] = moment()
            .week(moment().week() + 1)
            .startOf('isoWeek')
            .format('YYYY-MM-DD')
          range[1] = moment()
            .week(moment().week() + 1)
            .endOf('isoWeek')
            .format('YYYY-MM-DD')
          break
        case 3:
          range[0] = moment()
            .month(moment().month())
            .startOf('month')
            .format('YYYY-MM-DD')
          range[1] = moment()
            .month(moment().month())
            .endOf('month')
            .format('YYYY-MM-DD')
          break
        case 4:
          range[0] = moment()
            .month(moment().month() - 1)
            .startOf('month')
            .format('YYYY-MM-DD')
          range[1] = moment()
            .month(moment().month() - 1)
            .endOf('month')
            .format('YYYY-MM-DD')
          break
        case 5:
          range[0] = moment()
            .month(moment().month() + 1)
            .startOf('month')
            .format('YYYY-MM-DD')
          range[1] = moment()
            .month(moment().month() + 1)
            .endOf('month')
            .format('YYYY-MM-DD')
          break
      }
      range[0] = range[0] + ' 00:00:00'
      range[1] = range[1] + ' 23:59:59'
      return range
    },
    handleDateRangeFocus(item) {
      if (item.fillOnfocus) {
        const newItemValue = [...item.itemValue]
        if (!item.itemValue[0]) {
          newItemValue[0] = moment()
            .subtract(7, 'days')
            .format('YYYY-MM-DD')
        }
        if (!item.itemValue[1]) {
          newItemValue[1] = moment().format('YYYY-MM-DD')
        }
        item.itemValue = newItemValue
      }
    },
    handleDateRangeBlur(item) {
      if (item.fillOnfocus) {
        let newItemValue = [...item.itemValue]
        if (!item.itemValue[0]) {
          newItemValue = []
        }
        if (!item.itemValue[1]) {
          newItemValue = []
        }
        item.itemValue = newItemValue
      }
    },
    setDefault(index, rows) {
      const defaultDefault = this.perConfigs.find(item => item.bDefault === true)
      const defaultId = defaultDefault ? defaultDefault.id : ''
      const perConfig = rows[index]
      setDefault({
        newId: perConfig.id,
        oldId: defaultId
      })
        .then(res => {
          this.isShowAbc = false
          this.isShowSaveAs = false
          this.$message.success(this.$t('CargoMsg.Cargo_SchemeSaveSuccess'))
          return this.getPerConfigs(perConfig.configName) // 重新查询刚配置的方案
        })
        .then(() => {
          // this.$message.success('savePerConfigPost操作成功，测试先后')
        })
        .catch(err => {
          this.$message.error(err)
        })
    },
    // 状态追踪-业务类型发生改变
    async onLobInput(val) {
      this.sopStateTrack.cache.set(this.sopStateTrack.currentItem.itemName + this.sopStateLob, this.sopStateTrack.dialog.currentValue)
      this.sopStateLob = val
      await getTrackingInfoByLob(this.sopStateLob).then(res => {
        const values = {}
        let trackings = []
        if (this.lob === 'SE' || this.lob === 'AE' || this.lob === 'AI' || this.lob === 'RE') {
          trackings = res.data
        } else if (this.lob === 'SI') {
          for (const tracking of res.data) {
            if (tracking.nodeType === TrackingConstants.NOTE_TYPE_E.code) {
              continue
            }
            if (
              tracking.nodeType === TrackingConstants.NOTE_TYPE_SUPPLEMENT.code
            ) {
              continue
            }
            trackings.push(tracking)
          }
        }

        trackings.forEach(item => {
          // 初始化 结构
          values[item.code] = []
        })
        this.sopStateTrack.dialog.initCurrentValue = deepClone(values)
        let currentValue = this.sopStateTrack.cache.get(this.sopStateTrack.currentItem.itemName + this.sopStateLob)
        if (!currentValue) {
          currentValue = deepClone(values)
        }
        this.sopStateTrack.dialog.currentValue = currentValue
        this.sopStateTrack.dialog.data = trackings
      })
    },
    // 合作伙伴参数过滤方法
    companyMethodParamFilter(item) {
      let params = {}
      if (item) {
        if (item.subType && item.subType.type) {
          if (item.subType.type && item.subType.type instanceof Array) {
            if (item.subType.type.length > 0) {
              for (const key of item.subType.type) {
                if (!params.hasOwnProperty(key)) {
                  params[key] = true
                }
              }
            }
          } else {
            params = { [item.subType.type]: true }
          }
        } else {
          if (item.methodParams) {
            params = item.methodParams
          }
        }
        if (item.subType && item.subType.relation) {
          params['relation'] = item.subType.relation
          params['branchAndHeadOffice'] = item.subType.branchAndHeadOffice
        }
        if (item.subType && item.subType.officeIds) {
          params['officeIds'] = item.subType.officeIds
        }
        if (item.subType && item.subType.includeAllOffice) {
          params['includeAllOffice'] = item.subType.includeAllOffice
        }
      }
      return params
    },
    toShowEdiStateQueryDialog(item) {
      const dialog = this.ediStateQueryDialog
      dialog.title = this.$t(item.itemLabel)
      dialog.value = item.itemValue || {}
      dialog.callback = data => {
        item.itemValue = data.value || ''
        item.txtContent = data.txtContent
      }
      dialog.isCreate = true
      dialog.visible = true
    },
    toClearSpecialQuery(item) {
      item.itemValue = ''
      item.txtContent = ''
    },
    getAdvData() {
      const advRequestData = lodash.cloneDeep(this.getAdvRequestData())
      if (this.isAppendQuery) {
        advRequestData.push({
          appendQuery: this.appendQuery
        })
      }
      if (this.isBranchCooperate) {
        advRequestData.push({
          branchCooperate: this.branchCooperate
        })
      }
      return {
        conditions: advRequestData,
        simpleTriggerMode: false
      }
    },
    // 处理业务状态值的显示
    handleJobStates(item) {
      if (!item || !item.itemValue) {
        return item.itemValue
      }
      const curVal = [...item.itemValue]
      if (curVal && curVal instanceof Array && curVal.includes(SystemConstants.COMMITTING)) {
        const curJobStates = [...this.JOB_STATES]
        let flag = true
        for (const jobState of curJobStates) {
          if (jobState.code === SystemConstants.COMMITTING) {
            flag = false
            break
          }
        }
        if (flag) { // 下拉数据源未包含，则值需移除
          const index = curVal.indexOf(SystemConstants.COMMITTING)
          if (index !== -1) {
            curVal.splice(index, 1)
          }
          return curVal
        }
      }
      return item.itemValue
    },
    onInputEnter() {
      if (this.inputEnterQuery) {
        this.advSearch()
      }
    },
    clickCollapseList() {
      LocalStorageUtilsNew.setConfiguration('CollapseList-' + this.configModule, this.collapseList)
      if (!this.gridOptions) {
        return
      }
      // 确保所有节点展开或者折叠
      this.gridOptions.api.forEachNode(node => {
        node.setExpanded(!this.collapseList)
      })
    },
    datePickerChange(item) {
      this.handlerForTariffTableQuery(item)
    },
    // 运价表查询条件特殊处理
    handlerForTariffTableQuery(item = null) {
      if (this.configModule !== '223201') {
        return
      }
      if (!this.multipleSelection || this.multipleSelection.length === 0) {
        return
      }
      // 运价表， ETD查询条件变更的时候，如果“有效期”查询条件存在时，需要同步到有效期
      if (item && item.itemValue && item.itemName === 'price.ETD') {
        for (const condition of this.multipleSelection) {
          if (condition && condition.itemName === 'price.BEGIN_DATE') {
            condition.itemValue = [...item.itemValue]
            break
          }
        }
      }
    }
  }
}
</script>
<style lang="scss">
@import '~@/styles/element-variables.scss';

.cargo-advance-search {
  &-header {
    display: flex;
    width: 100%;
    padding-bottom: 5px;
    line-height: 28px;

    & > div {
      margin-left: 10px;

      &:nth-child(1) {
        margin-left: 0;
      }
    }
  }

  &-toggle-trigger {
    i {
      font-size: 24px;
      color: #ffffff;
      background-color: $--color-primary;
      vertical-align: middle;
      cursor: pointer;
      border: 1px solid $--color-primary;
      border-radius: 4px;
      margin-bottom: 1px;
      &:hover {
        background-color: $--color-primary-light-2;
      }
    }
  }

  &-quick {
  }

  &-operations {
    flex: 1;
  }

  &-more {
    &-operations {
      margin-bottom: 5px !important;
      display: flex;

      & > div:nth-child(1) {
        flex: 1;
      }
    }
  }

  &-form {
    .el-form-item {
      margin-bottom: 5px !important;
      &__label {
        height: 28px;
      }
      &__content {
        display: flex;
        flex-direction: row;
        align-items: center;

        .el-date-editor {
          .el-input__prefix {
            left: 0;

            .el-input__icon {
              width: 20px;
            }
          }

          .el-input__suffix {
            right: 0;

            .el-input__icon {
              width: 20px;
            }
          }

          .el-input__inner {
            padding-left: 20px;
            padding-right: 20px;
          }
        }
      }
    }
  }

  .extension-conditions-form {
    padding: 5px;

    .el-form {
      .el-col {
        margin-bottom: 5px;
      }
      margin-bottom: -5px;
    }
  }

  &-dialog {
    line-height: 28px;

    .el-dialog__body {
      .el-table .el-table__header th,
      .el-table .el-table__header tr,
      .el-table .el-table__body tr,
      .el-table .el-table__body td {
        padding: 0;
        height: 25px;
      }
    }
  }
}

.el-dropdown-menu {
  min-width: 100px;

  .el-dropdown-menu__item.activeMenu {
    background: $--color-primary;
    color: #fff;
  }
}

.save-modified-dialog {
  .el-form .el-form-item .el-checkbox__label {
    font-size: 12px;
    color: #666666 !important;
  }
}

.save-scheme-dialog {
  .el-form .el-form-item {
    .el-form-item__label, .el-checkbox__label {
      font-size: 12px;
      color: #666666 !important;
    }
  }
}
</style>
<style lang="scss" scoped>
.cargo-advance-search-quick{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.append-checkbox{
  margin-left: 10px;
  /deep/ .el-checkbox__label{
    padding-left: 5px;
  }
}
</style>
